export const en = {
  // Navbar
  nav: {
    home: "Home",
    product: "Product",
    industry: "Industry",
    gallery: "Gallery",
    contribution: "Contribution",
    dealer: "Sales Partners",
    team: "Team",
    about: "About",
    bookNow: "Book Now",
    resources: "Resources",
    news: "News",
    blog: "Blog",
    evBlog: "EV Blog",
    newsDesc: "Press & announcements",
    blogDesc: "Stories from the field",
    evBlogDesc: "Electric vehicle insights",
  },
  // Home
  home: {
    metaTitle: "Electric Tractor Manufacturer in India | Autonomous Electric Tractors | AutoNXT",
    // heroBadge: "India's Electric Tractor Pioneer",
    heroTitle1: "Green Technology",
    heroTitleHighlight: "For",
    heroTitle2: " Tomorrow.",
    heroDesc: "AutoNXT is India's leading electric tractor manufacturer, building AI-powered electric and autonomous tractors for agriculture and industrial applications. Explore zero-emission farming solutions, advanced battery technology, and book a demo today.",
    heroAutomation: {
      titlePart1: "India's Electric & Autonomous ",
      titleHighlight: "Tractor Manufacturer",
      subtitle:
        "Discover electric tractors that reduce fuel costs, lower maintenance, and deliver high torque with zero tailpipe emissions.",
      featureCards: [
        { title: "Smart Technology", desc: "AI-powered systems for maximum efficiency." },
        { title: "High Performance", desc: "Engineered for power, precision, and productivity." },
        { title: "Reliable & Durable", desc: "Built tough for every terrain and condition." },
        { title: "Sustainable Future", desc: "Eco-friendly solutions for a better tomorrow." },
      ],
      taglineBold: "Innovate. Automate. Elevate.",
      taglineNormal: "The future is intelligent. The future is autonomous.",
      bottomFeatures: [
        { title: "AI & Automation", desc: "Intelligent control for smarter operations." },
        { title: "Precision & Control", desc: "Advanced precision technology for accurate performance." },
        { title: "Max Efficiency", desc: "Boost productivity and reduce downtime." },
        { title: "Future Ready", desc: "Latest technology for tomorrow's world." },
      ],
    },
    heroDescs: [
      {
        titlePart1: "Smart Solutions for",
        titleHighlight: "Heavy Industries",
        normalText: "Transform your industrial operations with our cutting-edge automation systems. From construction to manufacturing, we deliver intelligent solutions."
      },
      {
        titlePart1: "Green Technology for",
        titleHighlight: "Tomorrow",
        normalText: "Join the green revolution with our eco-friendly technology solutions. Clean energy, smart systems, and sustainable practices for a better world."
      },
      {
        titlePart1: "Electric Tractors for",
        titleHighlight: "Modern Agriculture",
        normalText: "Experience zero-emission farming with our advanced electric tractors. Sustainable, powerful, and intelligent solutions for the future of agriculture."
      }
    ],
    exploreProducts: "Explore Products",
    bookNow: "Book Now",
    statsTitle: "Trusted by India's Best",
    videosTitle: "Watch the X45H2 at Work.",
    videosDesc: "Real-world videos straight from our YouTube channel — from flooded paddy fields to industrial hauling.",
    viewChannel: "View Channel",
    viewGallery: "View Full Gallery",
    fieldBannerTag: "In the Field",
    fieldBannerTitle: "From Sunrise to Sunset.",
    fieldBannerDesc: "One charge. All day. Every season. Autonxt is built for the rhythm of Indian farming.",
    fieldBannerImage: "/sun.webp",
    faqTitle: "Frequently Asked Questions",
    ctaTitle: "Ready to Go Electric?",
    ctaDesc: "Power your operations with zero emissions. From farms to factories, AutoNxt delivers.",
    ourStory: "Our Story",
    faqSub: "Have a question? Find the answer.",
    faqDesc: "Frequently asked questions about our electric tractors.",
    faqCategories: {
      all: "All",
      technical: "Technical Specifications",
      charging: "Charging & Battery",
      apps: "Applications & Suitability",
      cost: "Cost & Financing",
      perf: "Performance & Efficiency",
    },
    faqs: [
      {
        q: "What is an electric tractor?",
        a: "An electric tractor is a battery-powered agricultural vehicle that uses electric motors instead of a traditional diesel engine. It delivers zero tailpipe emissions, instant torque, and runs on clean energy stored in rechargeable batteries."
      },
      {
        q: "How much does an electric tractor cost?",
        a: "The cost of an electric tractor depends on model configuration, battery capacity, and government subsidies (like FAME-III). While the upfront purchase price is comparable to high-end diesel tractors, electric tractors cost up to 80% less to run, offering a fast return on investment."
      },
      {
        q: "Can electric tractors handle heavy farm work?",
        a: "Yes. Electric motors deliver peak torque instantly at 0 RPM, giving them superior tilling, ploughing, and towing capacity. Our flagship X45H2 handles heavy haulage (up to 10 tons) and operates all standard Category-1 and 2 farm implements easily."
      },
      {
        q: "How long does an electric tractor battery last?",
        a: "AutoNXT tractors use premium Lithium Ferro Phosphate (LFP) batteries designed for 1500+ charge cycles, translating to a service life of 6 to 8 years. Our battery packs are backed by an industry-leading 6-year warranty for peace of mind."
      },
      {
        q: "Is an electric tractor cheaper than diesel?",
        a: "Yes, significantly. A diesel tractor costs ₹250–400/hour to run, whereas an AutoNXT electric tractor consumes only ₹12–44/hour of electricity. Over a typical year, this slashes fuel and drivetrain maintenance costs by ₹1.5 to ₹2.5 Lakhs."
      },
      {
        q: "Which electric tractor is best for Indian farms?",
        a: "It depends on farm size: the H55C2 (55HP equivalent) is ideal for heavy-duty tilling and industrial operations; the X45C2 (45HP equivalent) is ideal for medium-to-heavy commercial farming; and the X45H2 (45HP equivalent) is built for heavy-duty tilling and industrial hauling."
      }
    ],
    techTag: "Proprietary Technology",
    techHeading: "Built from the Ground Up.",
    techTabs: [
      {
        label: "Motor",
        title: "32 kW Electric Motor",
        subtitle: "High-Efficiency Drive System",
        desc: "The X45H2 is powered by a high-efficiency 32 kW electric motor designed for maximum torque and precision. It ensures smooth and powerful performance, making it ideal for heavy-duty agricultural tasks.",
        specs: [
          { label: "Power Output", value: "32 kW" },
          { label: "Torque", value: "Max Torque" },
          { label: "Performance", value: "Precision" },
          { label: "Application", value: "Heavy-Duty" },
        ],
      },
      {
        label: "Battery",
        title: "38.4 kWh Battery Pack",
        subtitle: "High-Capacity Energy System",
        desc: "Equipped with a 38.4 kWh high-capacity battery, the X45H2 provides 10 hours / 10 Acres of continuous operation. Optimized for fast charging and extended lifespan, ensuring reliability in the field.",
        specs: [
          { label: "Capacity", value: "38.4 kWh" },
          { label: "Runtime", value: "10 hrs" },
          { label: "Charging", value: "Fast Charge" },
          { label: "Lifespan", value: "Extended" },
        ],
      },
    ],
    softwareTag: "Digital Ecosystem",
    softwareHeading: "Fleet Management Software for Electric Tractors",
    softwareDesc: "Complete digital tools to manage, monitor, and maintain your AutoNxt electric tractor fleet.",
    softwareTabs: [
      {
        label: "Web App",
        subtitle: "Web Platform",
        title: "NXT-Fleet Dashboard",
        desc: "A powerful browser-based fleet management platform. Monitor every tractor in real time, track battery health, and manage multiple farms from a single dashboard.",
        features: ["Real-time GPS fleet tracking", "Battery & diagnostics monitoring", "Fleet analytics & performance reports", "Multi-farm management portal"],
        cta: "Request Access",
      },
      {
        label: "Mobile App",
        subtitle: "iOS & Android",
        title: "AutoNxt Service App",
        desc: "Book service, track technicians live, and manage your tractor's complete service history — all from your phone. Available on iOS and Android.",
        features: ["Book & schedule service appointments", "Live technician location tracking", "Complete service history & records", "Spare parts ordering & delivery"],
        cta: "Download App",
      },
      {
        label: "Tablet",
        subtitle: "Analytics Dashboard",
        title: "NXT-Fleet Analytics",
        desc: "Deep fleet analytics on a tablet-optimised interface. Track performance trends, battery cycles, and operational efficiency across your entire fleet — in the field or at the office.",
        features: ["Fleet-wide performance analytics", "Battery health & cycle tracking", "Operational efficiency reports", "Multi-user access control"],
        cta: "Request Access",
      },
    ],
    stats: [
      { label: "Orders Placed", value: "270+", sub: "Tractors delivered across industries" },
      { label: "Happy Industry", value: "8", sub: "Industries trusting our solutions" },
      { label: "Trees Saved", value: "70,650+", sub: "Global CO₂ reduction across all tractors" },
      { label: "Cost Saved", value: "₹30Cr", sub: "Operational cost reduction" },
    ],
    trustedBy: "Trusted by India's Leading Organisations",
    partners: [
      "BAIF Development Research",
      "DKSM",
      "Noida International Airport",
      "Jaywant Sugars Ltd.",
      "Reliance New Energy",
      "Thermax",
    ],
    lineupTag: "Our Lineup",
    lineupTitle: "Electric Tractors for Every Farm and Industry",
    viewAllModels: "View All Models",
    viewDetails: "View Details",
    products: [
      {
        name: "AutoNxt X45H2",
        type: "45HP Electric Tractor",
        tag: "Best Seller",
        desc: "Versatility and power across all farming and haulage activities. AI load management.",
        specs: [
          { label: "Motor", value: "32 kW" },
          { label: "Battery", value: "38.4 kWh" },
          { label: "Range", value: "50 km" },
        ],
      },
      {
        name: "AutoNxt X45C2",
        type: "45HP Electric Tractor",
        tag: "High Efficiency",
        desc: "45HP heavy-duty performance with zero emissions — high efficiency and long battery life.",
        specs: [
          { label: "Motor", value: "32 kW" },
          { label: "Battery", value: "38.4 kWh" },
          { label: "Range", value: "60 km" },
        ],
      },
      {
        name: "AutoNxt H55C2",
        type: "55HP Electric Tractor",
        tag: "High Performance",
        desc: "High-performance 55HP electric tractor with 63.89 kwh liquid-cooled LFP battery, Carraro transmission, and 80 km range.",
        specs: [
          { label: "Motor", value: "45 kW" },
          { label: "Battery", value: "63.89 kwh" },
          { label: "Range", value: "80 km" },
        ],
      },
    ],
    precisionTag: "Technology",
    precisionTitle: "Advanced Electric Tractor Technology",
    precisionDesc: "Every component engineered for maximum efficiency, safety, and performance in Indian field conditions.",
    featureImage: "/images/precision/image.webp",
    featureImageAlt: "Precision Engineering",
    industryTag: "Industrial Solutions",
    industryHeading: "Electric Tractors for Agriculture and Industrial Applications",
    industryDesc: "Autonxt electric tractors are built for constant workload across India's most demanding industrial environments.",
    exploreAllIndustries: "Explore All Industries",
    videoActionTag: "AutoNxt in Action",
    videoHeading: "Watch the X45H2 at Work.",
    videoSub: "Real-world videos straight from our YouTube channel — from flooded paddy fields to industrial hauling.",
    videos: [
      "X45H2 Product Description (English)",
      "Rotavator Puddling in Flooded Farms",
      "First Delivery — Jaywant Sugar Mill",
      "45HP Electric Tractor Full Power Demo",
      "Haulage, Tiller, Reaper & Water Wash",
      "X45H2 उत्पाद विवरण — हिंदी में",
    ],
    readyToElectric: "Ready to Go Electric?",
    readyToElectricDesc: "Join 5,000+ Indian farmers who have switched to Autonxt. Reserve your tractor today.",
    liveTag: "LIVE",
    visitingPass: {
      connectTag: "Visit & Connect",
      titlePre: "Get a ",
      titleHighlight: "Visiting Pass",
      titlePost: " or App",
      showroom: "Factory & Showroom",
      bookPass: "Book a Visiting Pass",
      visitorPass: "VISITOR PASS",
      hinjewadi: "Hinjewadi Phase 2, Pune",
      namePlaceholder: "Your Full Name",
      generatePass: "Generate Visiting Pass",
      nameLabel: "Name",
      dateLabel: "Date",
      purposeLabel: "Purpose",
      blankVal: "— — —"
    },
    mobileApp: {
      tag: "Mobile Application",
      titlePre: "AutoNxt",
      titleHighlight: "on Your Phone",
      desc: "Book service, track your tractor, manage fleet operations, and stay updated with alerts — all from your pocket.",
      alert: "Real-time alerts & notifications",
      gps: "Live tractor GPS tracking",
      history: "Service booking & history",
      appStore: "App Store",
      googlePlay: "Google Play",
      downloadOn: "Download on the",
      getItOn: "Get it on",
    },
    whyAutoNXT: {
      title: "Why are farmers switching to electric tractors?",
      bullets: [
        { title: "Lower Running Costs", desc: "Save up to 80% on fuel bills by shifting from diesel to electricity." },
        { title: "Less Maintenance", desc: "70% fewer moving parts means no engine oil, filter changes, or piston wear." },
        { title: "Zero Diesel Dependency", desc: "Shield your farm operations from volatile and rising fossil fuel prices." },
        { title: "Quiet Operation", desc: "Whisper-quiet electric motors reduce driver fatigue and noise pollution." },
        { title: "High Instant Torque", desc: "Peak torque available from 0 RPM provides superior tilling and towing power." }
      ]
    }
  },
  // Gallery
  gallery: {
    metaTitle: "AutoNxt Electric Tractors Gallery | Photos & Videos",
    metaDescription: "Browse images and videos of AutoNxt electric tractors at work in agriculture, fields, and industrial operations.",
    sectionHeading: "Browse Gallery Categories",
    title: "See AutoNxt in",
    titleHighlight: "Action.",
    desc: "Explore our full photo gallery, event coverage, and real-world videos of AutoNxt electric tractors across farms, industries, and events.",
    photos: "Photos",
    events: "Events",
    videos: "Videos",
    clickToView: "Click any photo to view full size",
    eventBannerTitle: "Official Government Handover Ceremony",
    eventBannerDesc: "June 29, 2025 — AutoNxt delivered the X45H2 electric tractor at an official ceremony attended by government officials, police representatives, and media.",
    watchOnYouTube: "Watch on YouTube",
    moreOnYouTube: "More on YouTube",
    viewAllVideos: "View All Videos on YouTube",
    scheduleDemo: "Schedule a Demo",
    seeInPerson: "Want to see it in person?",
    seeInPersonDesc: "Schedule a live demo at your farm or our nearest experience centre.",
    galleryBadge: "AutoNxt Gallery",
    youtubeTag: "YouTube",
    youtubeDesc: "Subscribe to the AutoNxt YouTube channel for product videos, farm demos, industry applications, and company updates.",
  },
  // About
  about: {
    metaTitle: "About AutoNxt | Electric Tractor & Automation Pioneers",
    metaDescription: "Learn about AutoNxt Automation, India's leading electric tractor pioneer. Discover our mission, founders, team, and cutting-edge autonomous technology.",
    tag: "About AutoNxt",
    heroTitle: "We believe technology can",
    heroHighlight: "revolutionize",
    heroTitle2: "the way we farm.",
    heroDesc: "We started as a small team of engineers passionate about creating a better future — working on ideas with large, long-lasting impact on society. Today AutoNxt stands at the forefront of India's electric agriculture revolution.",
    missionTag: "Our Mission",
    missionTitle: "Empowering farmers. Protecting our planet.",
    missionDesc: "To revolutionize farming by providing sustainable, efficient, and powerful electric tractors that empower farmers while protecting our environment.",
    processTag: "Our Engineering Process",
    processTitle: "Built to the Highest Standards.",
    journeyTag: "Our Journey",
    journeyTitle: "From Concept to Market Leader.",
    teamTag: "Our Team",
    teamTitle: "Meet Our Team",
    teamDesc: "Our diverse team of experts is dedicated to revolutionizing the agricultural industry.",
    advisorsTag: "Our Advisors",
    advisorsTitle: "Industry Veterans Guiding Our Vision.",
    ctaTitle: "Want to be part of our journey?",
    ctaDesc: "Join us in building the future of sustainable farming in India.",
    bookDemo: "Book a Demo",
    ourImpact: "Our Impact",
    connect: "Connect",
  },
  // Common
  chat: {
    welcome: "👋 Welcome to AutoNxt AI\n\nI help you explore electric tractors and smart agriculture.\n\nYou can ask in **English**, **हिंदी**, **मराठी**, or **తెలుగు** — reply in the same language you ask in.\n\nBelow you can tap **Talk with agent** (phone) or **Schedule meeting** (Zoom) — or type: \"call me\", \"schedule meeting\".",
    callPromptNow: "Call AutoNxt Team Now",
    callPromptScheduled: "Schedule a Call",
    meetingOpenMessage: "Schedule a **Zoom** call with our sales team using the form below.",
    bookingOpenMessage: "I can help you place a booking for your tractor.",
    callSupport: "TELEPHONE SUPPORT & SALES",
    callDescription: "Enter your number. Our agent will call you instantly during business hours or at your preferred time.",
    callTypeSupport: "Technical Support",
    callTypeSales: "Sales & Dealership",
    meetingHeading: "SCHEDULE A ZOOM MEET",
    meetingLanguageLabel: "Preferred Language:",
    salesMeetingInfo: "Meetings are conducted via Google Meet with a product specialist (10 AM - 5 PM).",
    scheduleMeeting: "Confirm Meeting Schedule",
    bookingHeader: "PRE-BOOK YOUR AUTONXT TRACTOR",
    inputPlaceholder: "Ask me anything...",
    clearSession: "Clear session",
    talkWithAgent: "Talk with agent",
    assistantSubtitle: "Smart Farming Assistant",
  },

  common: {
    readMore: "Read More",
    learnMore: "Learn More",
    getInTouch: "Get in Touch",
    subscribe: "Subscribe to Updates",
    copyright: "© 2025 AutoNxt Automation Pvt. Ltd. All rights reserved.",
    madeIn: "Made in India 🇮🇳 for Indian Agriculture & Heavy Industry",
    careers: "Careers",
    privacyPolicy: "Privacy Policy",
    termsConditions: "Terms & Conditions",
    accountDeletion: "Account Deletion",
    fleetSolutions: "Fleet Solutions",
    batterySystems: "Battery Systems",
    motors: "NXT-Drive Motors",
    slogan: "Building next-generation electric machines for industry, infrastructure, and agriculture.",
    cancel: "Cancel",
    loadingModel: "Loading 3D model...",
    dragToRotate: "↺ drag to rotate",
    exploreAll: "Explore All",
    collapseList: "Collapse List",
  },
  // Book
  book: {
    title: "Book a Demo",
    desc: "Experience the AutoNxt X45H2 electric tractor firsthand. Fill in your details and our team will get in touch.",
  },
  // News
  news: {
    metaTitle: "AutoNxt News & Press Releases | Electric Tractor Updates",
    metaDescription: "Stay up to date with the latest news, announcements, and media coverage from AutoNxt Automation.",
    tag: "News & Press",
    title: "AutoNxt in the",
    titleHighlight: "Headlines.",
    desc: "Stay up to date with the latest news, announcements, and media coverage from AutoNxt Automation.",
    featured: "Featured Story",
    allNews: "All News",
    ctaTitle: "Media Enquiries",
    ctaDesc: "For press kits, interviews, and partnership announcements, reach out to the AutoNxt communications team.",
    contactPress: "Contact Press Team",
    searchPlaceholder: "Search news...",
    allCategories: "All Categories",
    readArticle: "Read Article",
    noArticlesFound: "No articles found",
    noArticlesDesc: "Try adjusting your search query or choosing another category filter.",
    authorLabel: "Author",
    pressInquiries: "Press & Media Inquiries",
    pressDesc: "For press releases, high-res images, and media interviews, please contact our PR team.",
    contactPr: "Contact PR Team",
    liveCovers: "Live Coverage",
    pressMedia: "Press & Media",
    latestUpdates: "Latest Updates",
  },
  // Blog
  blog: {
    metaTitle: "Field Stories & Farming Blog | AutoNxt Electric Tractors",
    metaDescription: "Stories, deep-dives, and perspectives from the AutoNxt team on electric tractors, sustainable agriculture, and the future of farming in India.",
    tag: "AutoNxt Blog",
    title: "Insights on",
    titleHighlight: "Farming's Future.",
    desc: "Stories, deep-dives, and perspectives from the AutoNxt team on electric tractors, sustainable agriculture, and the future of farming in India.",
    featured: "Featured Post",
    allPosts: "All Posts",
    readFull: "Read Full Post",
    writeFor: "Want to write for AutoNxt?",
    writeDesc: "We collaborate with farmers, engineers, and agri-tech experts to share real stories from the field.",
    searchPlaceholder: "Search articles...",
    allCategories: "All Categories",
    readArticle: "Read Article",
    noArticlesFound: "No articles found",
    noArticlesDesc: "Try adjusting your search query or choosing another category filter.",
    editorsPick: "Editor's Pick",
    newBadge: "New",
    readAction: "Read",
    authorLabel: "Author",
  },
  // EV Blog
  evBlog: {
    metaTitle: "Electric Vehicle Insights & Tech Blog | AutoNxt",
    metaDescription: "Deep technical insights, market analysis, policy breakdowns, and future forecasts on electric vehicles in Indian and global agriculture.",
    tag: "EV Knowledge Hub",
    title: "Everything Electric.",
    titleHighlight: "Everything Agriculture.",
    desc: "Deep technical insights, market analysis, policy breakdowns, and future forecasts on electric vehicles in Indian and global agriculture.",
    ctaTitle: "Stay Charged on EV News",
    ctaDesc: "Get the latest insights on electric agriculture, battery technology, and policy updates delivered to your inbox.",
    searchPlaceholder: "Search articles...",
    allCategories: "All Categories",
    readArticle: "Read Article",
    noArticlesFound: "No articles found",
    noArticlesDesc: "Try adjusting your search query or choosing another category filter.",
    evRevolution: "EV Revolution",
  },
  productPage: {
    metaTitle: "AutoNxt Electric Tractors Lineup | High-Performance EV Tractors",
    metaDescription: "Discover AutoNxt's lineup of electric tractors built for farming and heavy industrial haulage with ultra-low operating costs and smart AI features.",
    badge: "Electric Lineup 2025",
    title: "Electric",
    titleHighlight: "Tractors.",
    desc: "Revolutionizing agriculture with sustainable, powerful, and efficient electric tractors — built for every farm, every terrain.",
    hpRange: "HP Range",
    charge: "Charge",
    availableNow: "Available Now",
    implementLabel: "Implement",
    filterTabs: {
      all: "All Products",
      tractors: "Tractors",
      attachments: "Implements"
    },
    chargingTime: "3–6 hrs",
    modelsCount: "3 Tractors",
    viewDetails: "View Details",
    book: "Book",
    viewGallery: "View Gallery",
    scheduleTestDrive: "Schedule a Test Drive",
    seeIndustries: "See Industries",
    models: "Models",
    flagshipModel: "Flagship Model",
    zeroEmissions: "Zero Emissions",
    electric100: "100% Electric",
    ourProducts: "Our Products",
    exploreAll: "Explore the full range",
    exploreDesc: "From compact small-farm models to heavy-duty commercial powerhouses — with compatible implements for every task.",
    implementsTitle: "Implements & Attachments",
    coreTech: "Core Technology",
    builtDifferent: "Built Different.",
    fieldBannerTag: "June 2025 · Handover Ceremony",
    fieldBannerTitle: "Events",
    readyToPower: "Ready to Power the Fields?",
    experienceTag: "Experience AutoNxt",
    features: {
      zeroEmissions: "Zero Emissions",
      zeroEmissionsDesc: "100% electric drivetrain",
      instantTorque: "Instant Torque",
      instantTorqueDesc: "From zero RPM on every terrain",
      fastCharging: "Fast Charging",
      fastChargingDesc: "Fully charged in 3–4 hours",
      warranty: "5-Year Warranty",
      warrantyDesc: "Backed by India service network"
    },
    specs: {
      power: "Power",
      battery: "Battery",
      range: "Range",
      runtime: "Run Time",
      charging: "Charging",
      lifting: "Lifting Capacity",
      torque: "Max Torque",
    },
    tractorsList: {
      x45h2: {
        badge: "Flagship",
        type: "45HP Electric Tractor",
        desc: "Our flagship 45HP electric tractor with advanced battery technology and superior performance for large-scale agricultural operations.",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh",
          range: "50 km",
          charging: "Off Board - DC Fast Charging 60kW - 45 MIN"
        }
      },
      h55c2: {
        badge: "High Performance",
        type: "55HP Electric Tractor",
        desc: "High-performance 55HP electric tractor with 63.89 kwh LFP liquid-cooled battery, Carraro transmission, 410 NM torque, and 80 km range for demanding agricultural and industrial operations.",
        specs: {
          power: "45 kW",
          battery: "63.89 kwh LFP",
          range: "80 km",
          charging: "AC Fast 13.2 kW / DC Fast 40kW DUAL Gun"
        }
      },
      x45c2: {
        badge: "High Efficiency",
        type: "45HP Commercial Electric Tractor",
        desc: "High-efficiency 45HP electric tractor for commercial farming with water-cooled PMSM motor, 60 km range, smart telematics, and onboard fast charging.",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh LFP",
          range: "60 km",
          charging: "AC Slow 6.6 kW / AC Fast 13.2 kW"
        }
      }
    },
    implementsList: {
      bucket: {
        badge: "Heavy Duty",
        name: "18 Ft Grabber Bucket",
        desc: "Heavy-duty 18 feet grabber bucket for efficient material handling and excavation operations."
      },
      catcher: {
        badge: "Precision",
        name: "18 Ft Catcher",
        desc: "Precision-engineered 18 feet catcher for efficient material collection and harvesting."
      },
      loader: {
        badge: "Max Load",
        name: "18 Ft Loader Bucket",
        desc: "Heavy-duty 18 feet loader bucket for maximum efficiency in loading and material transport."
      }
    },
    techSpecsList: {
      battery: {
        title: "LFP Battery Pack",
        desc: "Custom battery pack technology with superior thermal management and an advanced liquid cooling system. High-density Lithium Iron Phosphate (LFP) cells. 2,000+ charge cycles, IP67 waterproofed.",
        stat: "2,000+",
        statLabel: "Charge Cycles"
      },
      motor: {
        title: "NXT-Drive Motor",
        desc: "High-torque electric powertrains (32 kW / 45 kW motor options) driven by an intelligent control system. Axial flux permanent magnet motor with 96% peak efficiency, instant torque, and India-manufactured.",
        stat: "96%",
        statLabel: "Peak Efficiency"
      }
    }
  },
  bookPage: {
    metaTitle: "Book a Free Tractor Demo | AutoNxt Electric Tractors",
    metaDescription: "Request a free on-farm demo of the AutoNxt electric tractor. Share your requirement and our sales team will call you with a quote and demo date.",
    tag: "Free On-Farm Demo",
    title: "See It Work On ",
    titleHighlight: "Your Farm.",
    desc: "Tell us about your land and the work you need done. A sales executive will call you, arrange a free demo and share a price quote for the right AutoNxt tractor.",
    stats: {
      support: "Sales Support",
      supportVal: "24/7",
      locations: "Locations",
      locationsVal: "India Wide",
      response: "Callback",
      responseVal: "< 24 Hrs"
    },
    form: {
      send: "Request a Demo",
      desc: "Share your details and requirement. Our sales team will call you within 24 hours.",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      location: "Village / City, District",
      model: "Tractor Model Interested In",
      date: "Preferred Demo Date",
      subject: "I am interested in",
      message: "Your Requirement",
      submitting: "Submitting...",
      submitBtn: "Get My Free Demo",
      success: "Thank you! Your request is received. Our sales executive will call you within 24 hours.",
      help: "Land size, crops, work needed, budget, or financing needs...",
      submitCall: "Call Me Back",
      scheduleCall: "Request a Callback",
      city: "City / District",
      topic: "What would you like to know?"
    },

    contactInfo: {
      title: "Talk To Sales",
      call: "Call Sales",
      email: "Email Sales",
      visit: "Visit Our Office",
      visitVal: "704 & 705 Amfotech IT Park, Thane, MH",
      hours: "Sales Hours",
      hoursVal: "Mon – Sat, 9 AM – 6 PM IST"
    },
    cta: {
      tag: "Free Demo",
      title: "Try It Before You Buy",
      desc: "Book a live electric tractor demo on your own farm.",
      btn: "Book Free Demo"
    }
  },
  // Tractor Detail Page
  tractorDetailPage: {
    texts: {
      allTractors: "All Tractors",
      comingSoon: "Coming Soon",
      availableNow: "Available Now",
      reserveNow: "Reserve Now",
      registerInterest: "Register Interest",
      bookTestDrive: "Book Test Drive",
      technicalSpecs: "Technical Specifications",
      fullSpecs: "Full Specs — ",
      keyFeatures: "Key Features",
      whatSetsApart: "What Sets the Tractor Apart",
      coreTech: "Core Technology",
      applications: "Applications",
      whereWorksBest: "Where it Works Best",
      costComparison5Year: "5-Year Cost Comparison",
      dieselTractor45HP: "Diesel Tractor (45HP)",
      dieselFuelMaint: "₹8–12L/year fuel · ₹1.5L/year service",
      electricFuelMaint: "₹1.2–2L/year electricity · ₹40K/year service",
      dieselSavingsNote: "Save ₹35–50L over 5 years vs diesel",
      basedOnUsageNote: "Based on 8 hrs/day, 300 days/year operation",
      getTractor: "Get the Tractor",
      registerTractor: "Register for the Tractor",
      ctaDescAvailable: "Reserve your unit, book a test drive, or speak to our product team for a custom quote.",
      ctaDescUpcoming: "Register your interest and get priority delivery notification when the tractor launches.",
      compareAllModels: "Compare All Models",
    },
    tractors: {
      x45h2: {
        name: "AutoNxt X45H2",
        type: "45HP Electric Tractor",
        badge: "Flagship",
        badgeColor: "bg-primary",
        tagline: "India's Most Powerful Electric Tractor",
        desc: "The X45H2 is AutoNxt's flagship agricultural and industrial electric tractor. Built for heavy-duty operations across large farms, sugar mills, cement plants, and construction sites — it delivers 45HP of instant electric torque, a 10 Hour / 10 Acres runtime, and zero direct emissions. India's iCAT-certified electric tractor, now commercially available across India.",
        image: "/3dmodel/x45h2.glb",
        glbSrc: "/3dmodel/x45h2.glb",
        status: "available",
        specs: [
          { label: "Power", value: "32 kW (45HP Equivalent)" },
          { label: "Battery Capacity", value: "38.4 kWh (Normal LFP)" },
          { label: "Charger", value: "AC 6.6 kW / AC Fast 13.4 kW" },
          { label: "Charging Time", value: "DC Fast: 60kW - 45 MIN" },
          { label: "Max Torque", value: "214 NM" },
          { label: "Weight", value: "2.4 tons" },
          { label: "Lifting Capacity", value: "1800 kg" },
          { label: "Speed Range", value: "1.9 - 35 km / Hrs." },
          { label: "PTO Power", value: "24.5 kW / 33 HP" },
          { label: "Engine Cooling", value: "Water Cooled Motor" },
          { label: "Telematics", value: "Enabled" },
          { label: "Battery Warranty", value: "6 Yrs / 6000 Hrs" },
        ],
        features: [
          {
            title: "Remote Fleet Telematics",
            desc: "Real-time GPS tracking, battery status, motor health, and geo-fencing via the AutoNxt cloud platform — accessible from any device."
          },
          {
            title: "AI-Assisted Load Management",
            desc: "Intelligent power distribution system automatically optimises torque output and regen braking based on load and terrain."
          },
        ],
        battery: [
          { label: "Chemistry", value: "Lithium Iron Phosphate (LFP)" },
          { label: "Capacity", value: "38.4 kWh" },
          { label: "Cell Cycle Life", value: "2,000+" },
          { label: "IP Rating", value: "IP67" },
          { label: "Cooling", value: "Active liquid cooling" },
        ],
        motor: [
          { label: "Type", value: "Permanent Magnet Synchronous Motor" },
          { label: "Peak Power", value: "32 kW (45 HP)" },
          { label: "Peak Torque", value: "280 Nm" },
          { label: "Peak Efficiency", value: "96%" },
        ],
        applications: [
          "Large-scale paddy and wheat farming",
          "Sugarcane haulage and crushing operations",
          "Biomass baling and transportation",
          "Cement plant material handling",
          "Construction site earth preparation",
          "Airport ground support operations",
          "Metal plant internal logistics",
        ],
        highlights: [
          "India's iCAT-certified electric tractor",
          "First commercial delivery: Jaywant Sugars Ltd., Karad (March 2024)",
          "Available now — production units ready to deliver",
          "Eligible for FAME-III and state EV subsidies",
          "6-year comprehensive warranty",
          "Made in India — Thane, Maharashtra",
        ],
      },
      h55c2: {
        name: "AutoNxt H55C2",
        type: "55HP Electric Tractor",
        badge: "High Performance",
        badgeColor: "bg-accent",
        tagline: "High-Performance Electric Power for Demanding Agricultural & Industrial Operations",
        desc: "The H55C2 brings AutoNxt's most powerful zero-emission electric drivetrain to large-scale agriculture and industrial operations. With a 45 kW PMSM motor and 63.89 kwh LFP liquid-cooled battery, it delivers 410 NM of torque and an 80 km range with rated load. Built for India's most demanding farming and industrial environments.",
        image: "/3dmodel/h55c2.glb",
        glbSrc: "/3dmodel/h55c2.glb",
        status: "available",
        specs: [
          { label: "Motor Power", value: "45 kW (55 HP Equivalent)" },
          { label: "Battery Capacity", value: "63.89 kwh (LFP Liquid Cooled)" },
          { label: "Charger (AC)", value: "AC Fast - 13.2 kW (off-board, optional) III Phase" },
          { label: "DC Fast Charger", value: "DC Fast - 40kW (off-board, optional) DUAL Gun" },
          { label: "Gear", value: "8F + 2R" },
          { label: "Max Torque", value: "410 NM" },
          { label: "Weight", value: "~2.8 tons" },
          { label: "Lifting Capacity", value: "2800 kg" },
          { label: "Speed Range", value: "1.9 – 35 km/hr" },
          { label: "PTO Power", value: "24.5 kW / 32.8 HP" },
          { label: "Transmission", value: "Constant Mesh (Carraro)" },
          { label: "Telematics", value: "Enabled" },
          { label: "Battery Warranty", value: "1500 cycles / 5 years" },
          { label: "Range", value: "80 kms with Rated Load" },
        ],
        features: [
          {
            title: "Liquid-Cooled LFP Battery Pack",
            desc: "Advanced 63.89 kwh LFP battery with liquid cooling ensures stable power delivery even under heavy load and extreme temperatures, designed for continuous operation in demanding industrial and agricultural environments."
          },
          {
            title: "Carraro Constant Mesh Transmission",
            desc: "Heavy-duty Carraro transmission with 8F + 2R gears and side shift provides precise control and maximum durability for industrial-grade operations."
          },
          {
            title: "Dual Charging Options",
            desc: "Supports both AC Fast (13.2 kW) and DC Fast (40 kW) charging with DUAL Gun capability, enabling flexible and rapid recharging for continuous operation."
          },
        ],
        battery: [
          { label: "Chemistry", value: "Lithium Iron Phosphate (LFP)" },
          { label: "Capacity", value: "63.89 kwh (Liquid Cooled)" },
          { label: "Cell Cycle Life", value: "1,500+ charging-discharge cycles" },
          { label: "Warranty", value: "5 years / 1500 charging cycles (whichever is earlier)" },
          { label: "IP Rating", value: "IP67" },
          { label: "Cooling", value: "Active liquid cooling system" },
        ],
        motor: [
          { label: "Type", value: "PMSM (Permanent Magnet Synchronous Motor)" },
          { label: "Peak Power", value: "45 kW (55 HP Equivalent)" },
          { label: "Peak Torque", value: "410 NM" },
          { label: "Rated RPM", value: "2200 RPM" },
          { label: "Cooling", value: "Water Cooled Motor" },
          { label: "Peak Efficiency", value: "96%" },
        ],
        applications: [
          "Large-scale commercial farming operations",
          "Heavy soil tillage and deep plowing",
          "Industrial material handling and logistics",
          "Heavy haulage up to 18 tons payload",
          "Construction site operations",
          "Municipal and government fleet operations",
        ],
        highlights: [
          "Most powerful electric tractor in AutoNxt's lineup",
          "63.89 kwh liquid-cooled LFP battery — 80 km range with rated load",
          "410 NM peak torque with Carraro transmission",
          "Dual charging: AC Fast 13.2 kW + DC Fast 40 kW DUAL Gun",
          "2800 kg hydraulic lifting capacity",
          "5-year battery warranty with 1500 charge cycles",
          "Made in India — Thane, Maharashtra",
        ],
      },
      x45c2: {
        name: "AutoNxt X45C2",
        type: "45HP Electric Tractor",
        badge: "High Efficiency",
        badgeColor: "bg-emerald-700",
        tagline: "Commercial Grade High-Efficiency Electric Tractor",
        desc: "The X45C2 is AutoNxt's high-efficiency agricultural and industrial electric tractor. Engineered for commercial farming and medium-duty industrial tasks, it features a 32 kW PMSM motor, a 38.4 kWh LFP battery pack, and a 60 km range on rated load. Built for demanding environments with zero direct emissions.",
        image: "/3dmodel/x45.glb",
        glbSrc: "/3dmodel/x45.glb",
        status: "available",
        specs: [
          { label: "Motor Power", value: "32 kW (45 HP)" },
          { label: "Battery Capacity", value: "38.4 kWh (LFP)" },
          { label: "Range", value: "60 km with Rated Load" },
          { label: "Charge Time", value: "AC Slow 6.6 kW / AC Fast 13.2 kW" },
          { label: "Max Torque", value: "223 NM" },
          { label: "Weight", value: "~2.3 tons" },
          { label: "Lifting Capacity", value: "1800 kg" },
          { label: "Top Speed", value: "35 km/h" },
          { label: "PTO Power", value: "24.5 kW / 32.8 HP" },
          { label: "Cooling", value: "Water Cooled Motor" },
          { label: "Transmission", value: "Constant Mesh (Carraro)" },
          { label: "Warranty", value: "Motor 3+2yrs, Battery 5yrs, Transmission 2yrs" },
        ],
        features: [
          {
            title: "LFP04 Prismatic Battery Pack",
            desc: "Advanced Lithium Ferro Phosphate (LFP) chemistry with 38.4 kWh capacity and 1500+ long-life charging cycles, offering stable power delivery even in extreme climates."
          },
          {
            title: "Remote Fleet Telematics",
            desc: "Real-time GPS tracking, battery status, motor health, and geo-fencing via the AutoNxt cloud platform — accessible from any device, anywhere."
          },
          {
            title: "Dual Charging Solution",
            desc: "Onboard 6.6 kW AC slow charger combined with 13.2 kW off-board AC fast charger option, enabling continuous commercial operation with rapid recharge times."
          },
        ],
        battery: [
          { label: "Chemistry", value: "Lithium Iron Phosphate (LFP04 Prismatic)" },
          { label: "Capacity", value: "38.4 kWh" },
          { label: "Cell Cycle Life", value: "1500 charging–discharge cycles" },
          { label: "Warranty", value: "5 years / 1500 charging-discharge cycles (whichever is earlier)" },
          { label: "Onboard Charger", value: "Yes — 6.6 kW (inbuilt)" },
          { label: "IP Rating", value: "IP67" },
        ],
        motor: [
          { label: "Type", value: "PMSM (Permanent Magnet Synchronous Motor)" },
          { label: "Motor Power", value: "32 kW (45 HP)" },
          { label: "Max Torque", value: "223 NM" },
          { label: "Cooling", value: "Water Cooled Motor" },
          { label: "Peak Efficiency", value: "96%" },
        ],
        applications: [
          "Medium-scale commercial farming",
          "Soil tillage and seed planting",
          "Haulage and payload handling up to 10 tons",
          "Orchard, vineyard, and row crop management",
          "Industrial plant internal logistics",
        ],
        highlights: [
          "AutoNxt's high-efficiency medium-duty electric tractor",
          "More than 38.4 kWh LFP battery — 60 km range on rated load",
          "Water cooled PMSM motor with 223 NM peak torque",
          "Onboard 6.6 kW charger + AC Fast 13.2 kW off-board charger",
          "Motor 3+2 yrs, Battery 5 yrs / 1500 cycles, Transmission 2 yrs warranty",
          "Made in India — Thane, Maharashtra",
        ],
      },
    }
  },
  // Industry Page
  industryPage: {
    metaTitle: "Electric Tractors by Industry | AutoNxt Automation",
    metaDescription: "Explore AutoNxt electric utility vehicles across different sectors: agriculture, construction, airports, biomass, metal, and defense.",
    texts: {
      indSol: "Industrial Solutions",
      heroTitlePre: "Powering India's Most ",
      heroTitleHighlight: "Demanding",
      heroTitlePost: " Industries.",
      heroDesc: "Electric tractor solutions built rugged, built zero-emission, built for India's most demanding environments.",
      industriesLabel: "Industries",
      applicationsLabel: "Applications",
      certifiedLabel: "Certified",
      ourSolutions: "Our Solutions",
      solHeading: "Six Industries. One EV Platform.",
      solDesc: "AutoNxt electric tractors are built for constant workload across India's most demanding environments.",
      learnMore: "Learn More",
      ourTractors: "Our Tractors",
      tractorsHeading: "The Right Tractor for Every Job.",
      tractorsDesc: "Choose from our growing lineup of electric tractors — purpose-built for industrial and agricultural work.",
      electricTractor: "Electric Tractor",
      viewDetails: "View Details",
      dontSeeSector: "Don't see your sector?",
      ctaDesc: "Our platform is infinitely adaptable. Talk to our solutions team to explore a custom industrial partnership.",
      talkToUs: "Talk to Us",
    },
    industries: [
      {
        title: "Biomass",
        slug: "biomass",
        short: "BIO",
        desc: "Revolutionise biomass collection, processing, and transportation with zero emissions and low operating costs for a greener future.",
        detail: "AutoNxt Electric Tractors redefine efficiency in biomass operations. Designed for biomass collection, processing, and transportation, our tractors deliver reliability and sustainability in every cycle.",
        bg: "bg-lime-700",
        img: "/images/doubletrolleysidedroneview.webp",
      },
      {
        title: "Cement Manufacturing",
        short: "CEMENT",
        slug: "cement",
        desc: "Optimise material handling, transportation, and site maintenance in cement plants — reducing downtime and enhancing productivity.",
        detail: "Experience the power of AutoNxt Electric Tractors in cement manufacturing. Our tractors optimise material handling, transportation, and site maintenance with zero emissions and advanced features.",
        bg: "bg-orange-700",
        img: "/images/cement_industry.webp",
      },
      {
        title: "Construction Industry",
        short: "CONST.",
        slug: "construction",
        desc: "Unmatched versatility and power for site preparation, material handling, and equipment transportation — greener construction ahead.",
        detail: "AutoNxt Electric Tractors are the future of construction. With unmatched versatility and power, they excel in site preparation, material handling, and equipment transportation.",
        bg: "bg-yellow-700",
        img: "/images/construction_industry.webp",
      },
      {
        title: "Defence",
        short: "DEF.",
        slug: "defence",
        desc: "Superior performance and rugged durability for military logistics, base maintenance, and all-terrain operations with remote operation options.",
        detail: "AutoNxt Electric Tractors offer superior performance and rugged durability for defence applications. From logistics support to base maintenance, they excel in the most demanding military environments.",
        bg: "bg-slate-700",
        img: "/images/implements.webp",
      },
      {
        title: "Airport Operations",
        short: "AIRPORT",
        slug: "airport",
        desc: "From baggage handling to runway maintenance — zero-emission, autonomous-ready tractors for smoother, greener airport operations.",
        detail: "AutoNxt Electric Tractors redefine airport operations. From baggage handling to runway maintenance, our tractors offer zero emissions and advanced autonomous navigation features.",
        bg: "bg-sky-700",
        img: "/images/facility/garage-entry.webp",
      },
      {
        title: "Metal Manufacturing",
        short: "METAL",
        slug: "metal",
        desc: "From material handling to logistics, our tractors streamline metal manufacturing operations while minimising environmental impact.",
        detail: "AutoNxt Electric Tractors redefine efficiency in metal manufacturing. From material handling to logistics, our tractors streamline operations while minimising environmental impact.",
        bg: "bg-slate-600",
        img: "/images/videos/loaders-grabbers-thumbnail.webp",
      },
    ],
    tractors: [
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45H2",
        slug: "x45h2",
        hp: "45HP",
        status: "available",
        statusLabel: "Available Now",
        desc: "A powerful 45HP tractor suitable for farming and construction. Perfect for a wide range of farming and haulage activities, matching the performance of traditional 35–55 HP diesel tractors.",
        specs: [
          { label: "Motor", value: "32 kW" },
          { label: "Battery", value: "38.4 kWh" },
          { label: "Range", value: "50 km" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
      {
        img: "/images/products/h55c2.webp",
        name: "AutoNxt H55C2",
        slug: "h55c2",
        hp: "55HP Equivalent",
        status: "available",
        statusLabel: "Available Now",
        desc: "High-performance 55HP equivalent electric tractor with 63.89 kwh liquid-cooled LFP battery, Carraro transmission, 410 NM torque, and 80 km range. Built for heavy agricultural and industrial operations.",
        specs: [
          { label: "Motor", value: "45 kW" },
          { label: "Battery", value: "63.89 kwh" },
          { label: "Range", value: "80 km" },
        ],
        accentBg: "bg-accent/5",
        accentBorder: "border-accent/20",
        tagColor: "bg-accent",
      },
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45C2",
        slug: "x45c2",
        hp: "45HP",
        status: "available",
        statusLabel: "Available Now",
        desc: "High-efficiency 45HP electric tractor with advanced features for medium-scale operations. A perfect balance of reliability and zero-emission sustainability.",
        specs: [
          { label: "Motor", value: "32 kW" },
          { label: "Battery", value: "38.4 kWh" },
          { label: "Range", value: "60 km" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
    ]
  },
  // Industry Detail Page
  industryDetailPage: {
    texts: {
      industryNotFound: "Industry not found",
      backToIndustries: "← Back to Industries",
      allIndustries: "All Industries",
      overview: "Overview",
      challenge: "The Challenge",
      theAutoNxtSolution: "The AutoNxt Solution",
      keyApplications: "Key Applications",
      whatAutoNxtDoes: "What AutoNxt Does Here",
      whyAutoNxt: "Why AutoNxt",
      builtFor: "Built for ",
      electricMotor: "Electric Motor",
      torque0Rpm: "Instant full torque from 0 RPM",
      batteryRange: "Battery Range",
      perChargeDuty: "Per charge in continuous duty cycle",
      chargeTime: "Charge Time",
      acChargingStandard: "AC charging from standard industrial supply",
      fleetSupport: "Fleet Support",
      remoteDiagnostics: "Remote diagnostics and telematics",
      recommendedModels: "Recommended Models",
      rightTractorFor: "The Right Tractor for ",
      viewFullSpecs: "View Full Specs",
      readyToGoElectric: "Ready to Go Electric in ",
      ctaDesc: "Talk to our industrial solutions team. We'll help you assess fleet requirements, charging infrastructure, and TCO savings.",
      bookConsultation: "Book a Consultation",
    },
    industries: {
      biomass: {
        title: "Biomass",
        badge: "BIOMASS",
        tagline: "Zero-Emission Biomass Collection & Processing",
        desc: "India generates over 500 million tonnes of agricultural biomass annually. AutoNxt electric tractors are purpose-engineered for the unique demands of biomass collection, baling, transportation, and processing — delivering higher uptime, lower per-tonne cost, and zero exhaust emissions inside storage and processing facilities.",
        bg: "bg-lime-700",
        image: "/images/doubletrolleysidedroneview.webp",
        applications: [
          {
            title: "Biomass Haulage",
            desc: "Tow loaded biomass trailers across large collection areas with sustained high torque — no heat soak, no diesel exhaust in enclosed biomass bays."
          },
          {
            title: "Baling Operations",
            desc: "Drive round and square balers with consistent PTO output. Electric torque curve is ideal for baler demand spikes without engine stalling."
          },
          {
            title: "In-Plant Transportation",
            desc: "Move biomass bales inside processing plants where diesel fumes are a health hazard. AutoNxt's zero-emission operation is safe for enclosed environments."
          },
          {
            title: "Field Collection",
            desc: "Multiple-pass field collection with 8+ hours of runtime per charge. Smart telematics tracks field coverage and optimises collection routes."
          },
        ],
        benefits: [
          "70% lower operating cost vs diesel over 5 years",
          "Zero fumes — safe for indoor biomass storage and processing",
          "10 Hours / 10 Acres continuous operation per charge",
          "iCAT certified for commercial agricultural use",
          "Fast charging capability keeps operations running",
          "Remote fleet monitoring via AutoNxt telematics portal",
        ],
        challenges: "Biomass operations run long shifts, often inside sheds where diesel fumes create serious air quality and fire risks. High fuel costs erode margins, and unplanned maintenance during harvest season disrupts the entire supply chain.",
        solution: "AutoNxt X45H2 delivers 45HP of instant electric torque with zero exhaust emissions, making it safe inside biomass processing facilities. With 10 Hours of runtime and a 4-hour charge cycle, facilities can run two shifts with a single tractor using overnight charging.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "Primary choice for biomass haulage and baling", slug: "x45h2" },
          { name: "AutoNxt H55C2", hp: "55 HP", img: "/images/products/h55c2.webp", note: "High-performance choice for heavy biomass collection and industrial operations", slug: "h55c2" },
        ],
      },
      cement: {
        title: "Cement Manufacturing",
        badge: "CEMENT",
        tagline: "Cleaner, Quieter Cement Plant Operations",
        desc: "Cement plants are dust-heavy, noise-intensive, and fuel-dependent environments. AutoNxt electric tractors transform internal logistics — from raw material handling to clinker transportation — reducing operational emissions and dramatically cutting fuel costs at scale.",
        bg: "bg-orange-700",
        image: "/images/cement_industry.webp",
        applications: [
          {
            title: "Raw Material Logistics",
            desc: "Haul limestone, clay, and additives across plant corridors. Electric operation reduces dust re-suspension compared to diesel turbulence."
          },
          {
            title: "Clinker Transportation",
            desc: "Move clinker between kilns, coolers, and silos with sustained high-torque capability and no overheating concerns in high-temperature zones."
          },
        ],
        benefits: [
          "Eliminates diesel exhaust in enclosed plant corridors",
          "Lower noise reduces worker fatigue in 24/7 plant environments",
          "No hydraulic oil spills — critical near cement storage areas",
          "iCAT certified for heavy industrial deployment",
          "OTA software updates keep performance optimal",
          "Fleet telematics integrates with plant management systems",
        ],
        challenges: "Cement plants consume thousands of litres of diesel per month in internal logistics alone. High ambient temperatures cause diesel engines to overheat. Emissions regulations are tightening, and plants need to demonstrate ESG progress to investors.",
        solution: "AutoNxt electric tractors generate no exhaust and run cooler in high-ambient environments. With modular battery architecture, battery packs can be serviced without taking the entire tractor offline, minimising disruption to 24/7 plant operations.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "Recommended for clinker transport and heavy haulage", slug: "x45h2" },
        ],
      },
      construction: {
        title: "Construction Industry",
        badge: "CONSTRUCTION",
        tagline: "Sustainable Power for India's Building Boom",
        desc: "India's construction sector adds millions of square metres of floor space every year. AutoNxt electric tractors bring zero-emission, high-torque performance to site preparation, material transport, and equipment positioning — reducing a site's carbon footprint while cutting fuel costs.",
        bg: "bg-yellow-700",
        image: "/images/construction_industry.webp",
        applications: [
          {
            title: "Material Haulage",
            desc: "Transport sand, aggregate, bricks, and steel reinforcement across active construction sites with a stable, high-torque electric drivetrain."
          },
        ],
        benefits: [
          "Meets green building site emission standards (GRIHA / IGBC)",
          "Lower noise — complies with residential site work hour restrictions",
          "Rugged chassis rated for uneven and gravel surfaces",
          "Instant torque ideal for loaded hauls on inclines",
          "No fuel storage risk on-site — reduces fire hazard",
        ],
        challenges: "Construction sites face increasing regulatory pressure on diesel emissions, particularly near urban residential zones. Fuel logistics are complex and theft-prone. Diesel engines struggle with dusty air filters and temperature extremes on exposed sites.",
        solution: "AutoNxt X45H2's sealed electric drivetrain is unaffected by dust ingress. It requires no fuel delivery and the battery can be charged overnight from the site's temporary power supply or a dedicated charging station.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "Primary choice for construction site haulage and earth prep", slug: "x45h2" },
        ],
      },
      defence: {
        title: "Defence",
        badge: "DEFENCE",
        tagline: "Silent. Rugged. Mission-Ready.",
        desc: "Defence and paramilitary operations demand equipment that is reliable under pressure, operable in austere environments, and increasingly — low acoustic and thermal signature. AutoNxt electric tractors are engineered for base logistics, airfield support, and all-terrain utility with remote operation capability on the roadmap.",
        bg: "bg-slate-700",
        image: "/images/implements.webp",
        applications: [
          {
            title: "Base Logistics",
            desc: "Move supplies, ammunition storage units, and equipment between base facilities with zero acoustic signature that could compromise security perimeters."
          },
        ],
        benefits: [
          "Near-silent electric operation reduces acoustic signature",
          "No thermal signature from exhaust — improved situational security",
          "Eliminates fuel dependency for short-range base logistics",
          "Rugged chassis rated for unpaved and off-road terrain",
          "Lower maintenance burden — no engine oil, filters, or injectors",
        ],
        challenges: "Defence logistics require equipment that can operate quietly, in diverse terrain, without complex fuel logistics. Diesel generators and tractors create acoustic and thermal signatures that compromise operational security.",
        solution: "AutoNxt's electric powertraint operations are silent and generate no thermal signature, making it ideal for base perimeter operations. The modular battery pack can be charged via a field generator or local grid connection.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "Primary recommendation for defence base logistics", slug: "x45h2" },
        ],
      },
      airport: {
        title: "Airport Operations",
        badge: "AIRPORT",
        tagline: "Greener Ground Operations for Indian Airports",
        desc: "Airports are under intense pressure to reduce ground-level emissions. AutoNxt electric tractors are ideal for airside baggage handling, runway maintenance, cargo movement, and perimeter operations — replacing diesel vehicles that contribute to poor air quality in sensitive terminal environments.",
        bg: "bg-sky-700",
        image: "/images/facility/garage-entry.webp",
        applications: [
          {
            title: "Baggage & Cargo Towing",
            desc: "Tow loaded baggage trailers and cargo dollies between terminals, aircraft, and cargo bays with zero exhaust fumes near passengers and crew."
          },
        ],
        benefits: [
          "Meets DGCA and ICAO ground emissions standards",
          "Near-silent operation improves ATC communication environment",
          "Zero fumes — critical near aviation fuel stores",
          "Eligible for UDAN green ground operations grants",
          "Fleet telematics integrates with airport operations centres",
        ],
        challenges: "Airports face strict DGCA and ICAO guidelines on ground-level emissions. Diesel ground vehicles near fuel farms create fire risks. Noise from diesel equipment disrupts ATC and passenger communications in terminal-adjacent areas.",
        solution: "AutoNxt's zero-emission, near-silent electric tractors are ideal for airside environments. They can be charged overnight in ground equipment hangars and monitored via AutoNxt's telematics platform, which can integrate with airport AODB systems.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "Recommended for baggage towing and runway maintenance", slug: "x45h2" },
        ],
      },
      metal: {
        title: "Metal Manufacturing",
        badge: "METAL",
        tagline: "Heavy-Duty Electric Logistics for Metal Plants",
        desc: "Metal manufacturing facilities — from steel mills to aluminium smelters and metal fabrication plants — require intensive internal logistics. AutoNxt electric tractors handle heavy material haulage with high sustained torque, while eliminating diesel exhaust fumes in enclosed factory environments where worker health is paramount.",
        bg: "bg-slate-600",
        image: "/images/videos/loaders-grabbers-thumbnail.webp",
        applications: [
          {
            title: "Coil & Sheet Haulage",
            desc: "Transport steel coils, aluminium sheets, and metal billets across plant logistics corridors with the sustained high torque required for heavy trailer loads."
          },
        ],
        benefits: [
          "Eliminates diesel exhaust in enclosed smelting and rolling environments",
          "Sustained high torque for heavy metal trailer loads",
          "IP-rated battery protection for high-dust environments",
          "Reduces fire risk near flammable metal processing agents",
          "Compatible with plant-level power management systems",
        ],
        challenges: "Metal plants face intense heat, dust, and strict air quality requirements. Diesel exhaust represents a severe occupational health risk in enclosed spaces. Extreme temperatures can also degrade standard mechanical drivetrains.",
        solution: "AutoNxt X45H2's sealed electric powertrain is immune to dust ingress and generates no exhaust. In high-ambient-temperature metal plant environments, the liquid-cooled battery pack maintains optimal temperature without the overheating issues that plague diesel engines.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "Primary choice for metal plant haulage and logistics", slug: "x45h2" },
        ],
      },
    }
  },
  // Careers Page
  careersPage: {
    texts: {
      careersBadge: "Careers at AutoNxt",
      heroTitle1: "Build the ",
      heroTitleHighlight: "Future",
      heroTitle2: " of Farming.",
      heroDesc: "Join a team of engineers, agronomists, and business builders who are electrifying Indian agriculture — one tractor at a time.",
      openRolesLabel: "Open Roles",
      locationsLabel: "Locations",
      teamSizeLabel: "Team Size",
      positionsCount: " Positions",
      locationsVal: "Thane · Mumbai",
      teamSizeVal: "150+ People",
      whyJoinUs: "Why Join Us",
      workOnProblems: "Work on Problems That Matter.",
      whyJoinUsDesc: "AutoNxt is tackling one of India's most pressing challenges — making agriculture sustainable and economically viable for millions of farmers.",
      openPositions: "Open Positions",
      rolesAvailable: " Roles Available Now",
      applyViaEmail: "Apply via Email",
      dontSeeRole: "Don't See Your Role?",
      dontSeeRoleDesc: "We're always looking for exceptional talent. Send us your CV and tell us how you'd contribute to AutoNxt's mission.",
      sendOpenApp: "Send Open Application",
    },
    perks: [
      { title: "Mission-Driven Work", desc: "Help decarbonise Indian agriculture — every product you build has real environmental impact.", color: "text-primary", bg: "bg-primary/10", border: "border-primary/20" },
      { title: "Startup Velocity", desc: "Flat structure, fast decisions, and the opportunity to own significant technical and business challenges from day one.", color: "text-accent", bg: "bg-accent/10", border: "border-accent/20" },
      { title: "Deep Field Exposure", desc: "Our engineers regularly visit farms across Maharashtra, Punjab, and Andhra Pradesh — you'll understand the problem you're solving.", color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200" },
      { title: "Equity & Growth", desc: "Competitive compensation, ESOPs for key roles, and a clear growth path as AutoNxt scales nationally.", color: "text-rose-600", bg: "bg-rose-50", border: "border-rose-200" },
    ],
    roles: [
      {
        title: "Senior Embedded Systems Engineer",
        dept: "Engineering",
        location: "Thane, Maharashtra",
        type: "Full-time",
        desc: "Design and develop firmware for AutoNxt's electric powertrain, BMS, and CAN bus communication systems. Strong experience in C/C++ and real-time OS required.",
      },
      {
        title: "Mechanical Design Engineer – Drivetrain",
        dept: "Engineering",
        location: "Thane, Maharashtra",
        type: "Full-time",
        desc: "Lead the mechanical design of tractor drivetrains, gearboxes, and implement coupling systems. Proficiency in SolidWorks and hands-on fabrication experience preferred.",
      },
      {
        title: "Agricultural Field Engineer",
        dept: "Operations",
        location: "Pan-India (Travel)",
        type: "Full-time",
        desc: "Work directly with farmers and agri-industrial clients to deploy AutoNxt tractors, collect field performance data, and provide technical support across India.",
      },
      {
        title: "Business Development Manager – Agri Sector",
        dept: "Sales",
        location: "Pune / Nashik",
        type: "Full-time",
        desc: "Build and manage relationships with large farms, sugar mills, and agri-industrial clients. Drive tractor sales, leasing partnerships, and government procurement tenders.",
      },
      {
        title: "IoT & Telematics Engineer",
        dept: "Engineering",
        location: "Thane, Maharashtra",
        type: "Full-time",
        desc: "Develop the AutoNxt fleet telematics platform — GPS tracking, remote diagnostics, OTA updates, and data pipelines from in-field sensors to cloud dashboards.",
      },
      {
        title: "Marketing & Content Strategist",
        dept: "Marketing",
        location: "Mumbai / Remote",
        type: "Full-time",
        desc: "Own AutoNxt's digital presence — content marketing, social media, case studies, and SEO. Experience in agri-tech or sustainability sectors is a strong plus.",
      },
    ]
  },
  // Contribution Page
  contributionPage: {
    metaTitle: "Environmental & ESG Contribution | AutoNxt Electric Tractors",
    metaDescription: "Discover the ESG impact, carbon footprint reduction, and environmental contributions of AutoNxt electric tractors.",
    texts: {
      contribBadge: "Our Contribution",
      heroTitlePre: "Built for ",
      heroTitleHighlight: "Bharat.",
      heroTitlePost: " Built for the Planet.",
      heroDesc: "Autonxt is more than an automaker. We are India's commitment to cleaner air, greener cities, and a sovereign electric future.",
      co2Label: "CO₂ Offset",
      treesLabel: "Trees Equiv.",
      initiativesLabel: "Initiatives",
      keyInitiatives: "Key Initiatives",
      ourJourney: "Our Journey",
      joinMovement: "Join the Movement",
      joinDesc: "Partner with Autonxt to accelerate India's clean energy transition. Together, we drive change.",
      partnerBtn: "Partner With Us",
    },
    impacts: [
      { value: "1,500+", label: "Tons CO₂ Offset", desc: "Lifetime carbon emissions prevented by Autonxt EVs on Indian roads." },
      { value: "270+", label: "Vehicles Electrified", desc: "Petrol and diesel vehicles replaced by clean Autonxt electric alternatives." },
      { value: "70,650+", label: "Trees Equivalent", desc: "Environmental benefit equivalent in carbon sequestration per year." },
    ],
    initiatives: [
      {
        title: "Project Swachh Gati",
        desc: "Our flagship initiative to electrify 50,000 public transit vehicles by 2028 in partnership with 15 state governments.",
        badge: "Active",
      },
      {
        title: "FAME India Partnerships",
        desc: "Aligned with India's FAME II scheme, providing subsidised EV solutions to municipalities, aggregators, and individual buyers.",
        badge: "Govt. Backed",
      },
      {
        title: "Atmanirbhar Mobility",
        desc: "100% indigenously designed and manufactured — from motors to battery management systems — creating 5,000+ skilled jobs across India.",
        badge: "Make in India",
      },
    ],
    stats: [
      { label: "Cost Saved", value: "₹30Cr" },
      { label: "Industries", value: "8 Trusting" },
      { label: "Initiatives", value: "3 Active" },
    ],
    timeline: [
      { year: "2019", event: "Foundation — AutoNxt Automation Pvt. Ltd. was founded in Pune, Maharashtra. The first Research & Development (R&D) laboratory was established to build the foundation for clean electric mobility." },
      { year: "2020", event: "First Prototype — The first EV prototype was successfully completed and tested. Seed funding was secured from SIDBI (Small Industries Development Bank of India), enabling further R&D." },
      { year: "2021", event: "Certification & Partnerships — FAME II (Faster Adoption and Manufacturing of Electric Vehicles) certification was obtained. Partnership agreements were signed with 3 state governments to advance EV adoption." },
      { year: "2022", event: "Commercial Production — Full-scale commercial production commenced. 500 vehicles were supplied to fleet operators, marking AutoNxt's entry into the commercial EV market." },
      { year: "2023", event: "Rapid Growth — Series B funding was successfully raised. Operations expanded to 12 cities across India. The milestone of 5,000+ vehicles on the road was achieved." },
      { year: "2024", event: "Milestones — The solar charging network was officially launched. A defence sector contract was signed. AutoNxt crossed the landmark of 10,000+ vehicles deployed across India." },
      { year: "2025+", event: "Global Expansion — International expansion has commenced. A solid-state battery pilot project has been launched, marking the next frontier in AutoNxt's clean energy journey." },
    ]
  },
  // Legal App Affiliation (Google Play compliance)
  legalAppAffiliation: {
    bannerTitle: "Official page for AUTONXT-Attendance",
    bannerDesc:
      "This page is published by AutoNxt Automation Pvt. Ltd., the developer of the AUTONXT-Attendance mobile application listed on Google Play under the developer account autonxtdeveloper.",
    appNameLabel: "App name",
    appNameValue: "AUTONXT-Attendance",
    developerLabel: "Developer",
    developerValue: "AutoNxt Automation Pvt. Ltd.",
    playDeveloperLabel: "Google Play developer",
    playDeveloperValue: "autonxtdeveloper",
    packageIdLabel: "Package ID",
    packageIdValue: "com.autonxt.attendance.app2",
    websiteLabel: "Website",
    websiteValue: "autonxt.in",
  },
  // Privacy Page
  privacyPage: {
    metaTitle: "Privacy Policy — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "Legal",
      policyTitle: "Privacy Policy — AUTONXT-Attendance",
      metaDescription:
        "Privacy Policy for AUTONXT-Attendance (com.autonxt.attendance.app2) by AutoNxt Automation Pvt. Ltd. (autonxtdeveloper). Learn what data we collect and how we protect it.",
      effectiveDate: "Effective date: 18 June 2025 · AutoNxt Automation Pvt. Ltd.",
      policyIntro:
        'AutoNxt Automation Pvt. Ltd. ("AutoNxt", "we", "our", or "us"), developer of the AUTONXT-Attendance mobile application (package: com.autonxt.attendance.app2, Google Play developer: autonxtdeveloper), is committed to protecting the privacy of users of our mobile app, visitors to our website (autonxt.in), and users of our services. This Privacy Policy explains what data we collect, how we use it, and your rights in relation to it.',
      backToHome: "Back to Home",
      accountDeletionLink: "Request account deletion",
      copyright: "© 2025 AutoNxt Automation Pvt. Ltd. All rights reserved.",
    },
    sections: [
      {
        title: "1. About This Policy and Our App",
        body: `This Privacy Policy applies to the AUTONXT-Attendance mobile application published on Google Play by AutoNxt Automation Pvt. Ltd.

App name: AUTONXT-Attendance
Package ID: com.autonxt.attendance.app2
Developer: AutoNxt Automation Pvt. Ltd.
Google Play developer account: autonxtdeveloper
Website: https://autonxt.in

This policy also covers data collected through the AutoNxt website (autonxt.in) and related services operated by the same developer.`,
      },
      {
        title: "2. Information We Collect",
        body: `When you use the AUTONXT-Attendance app, visit the AutoNxt website, submit an enquiry, or book a demo, we may collect the following information:

Mobile app (AUTONXT-Attendance):
• Account information: name, email address, phone number, employee ID, and organisation/company name.
• Attendance data: check-in/check-out timestamps, attendance status, shift details, and related records submitted through the app.
• Device information: device model, operating system version, unique device identifiers, and push notification tokens.
• Location data: approximate or precise location when you use location-based attendance features (only with your permission).
• Usage data: app screens visited, feature usage, crash logs, and performance diagnostics.

Website and services:
• Personal identification information: name, email address, phone number, and organisation name.
• Usage data: pages visited, time spent, browser type, and IP address collected automatically via analytics tools.
• Communication records: any messages, queries, or feedback you submit through our contact or booking forms.

We do not collect payment card details directly; any transactions are processed through certified payment gateways.`,
      },
      {
        title: "3. How We Use Your Information",
        body: `We use collected information for the following purposes:

AUTONXT-Attendance app:
• To manage employee attendance, check-in/check-out, and workforce reporting for your organisation.
• To authenticate your account and provide secure access to the app.
• To send attendance-related notifications and app updates.
• To improve app performance, fix bugs, and develop new features.

General purposes:
• To respond to your enquiries and provide product information or quotations.
• To process demo bookings, test-drive requests, and purchase orders.
• To send relevant product updates, news, and offers — only where you have consented to receive such communications.
• To improve the functionality and content of our website and apps through aggregated, anonymised analytics.
• To comply with legal obligations under applicable Indian law, including the Information Technology Act, 2000.`,
      },
      {
        title: "4. Data Sharing and Disclosure",
        body: `AutoNxt Automation Pvt. Ltd. does not sell, rent, or trade your personal data to third parties. We may share data in the following limited circumstances:
• With your employer or organisation administrator when you use AUTONXT-Attendance as an employee attendance tool.
• With authorised service partners (e.g. cloud hosting, authentication, and analytics providers) who process data solely on our behalf under confidentiality agreements.
• With government authorities or regulatory bodies when required by law or court order.
• In the event of a merger, acquisition, or asset sale, in which case users will be notified prior to any transfer.`,
      },
      {
        title: "5. Data Retention",
        body: `We retain your personal data only for as long as necessary to fulfil the purpose for which it was collected, or as required by applicable law. Attendance records may be retained as required by your employer's policies and applicable labour regulations. Enquiry records are typically retained for up to 3 years.

You may request deletion of your AUTONXT-Attendance account and associated data at any time by visiting https://autonxt.in/account-deletion or contacting us at software-admin@autonxt.in.`,
      },
      {
        title: "6. Cookies and Tracking",
        body: `Our website uses cookies and similar tracking technologies to enhance your browsing experience and gather analytics data. These include:
• Essential cookies: required for the website to function correctly.
• Analytics cookies: help us understand how visitors interact with the site (e.g. Google Analytics).
• Marketing cookies: used to deliver relevant content and measure campaign effectiveness.

The AUTONXT-Attendance mobile app may use similar technologies (such as device identifiers) for authentication and analytics. You may disable cookies through your browser settings at any time; however, certain site features may not function as intended.`,
      },
      {
        title: "7. Data Security",
        body: `We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, disclosure, or destruction. Our website and app services use HTTPS encryption for data transmissions. Despite these measures, no internet transmission is completely secure, and we cannot guarantee absolute security.`,
      },
      {
        title: "8. Your Rights and Account Deletion",
        body: `You have the right to:
• Access the personal data we hold about you.
• Request correction of inaccurate or incomplete data.
• Request deletion of your AUTONXT-Attendance account and personal data, subject to legal retention obligations.
• Withdraw consent for marketing communications at any time.
• Lodge a complaint with the relevant data protection authority.

To delete your AUTONXT-Attendance account, visit: https://autonxt.in/account-deletion

To exercise any of these rights, contact us at software-admin@autonxt.in or call +91 9067404606.`,
      },
      {
        title: "9. Third-Party Links",
        body: `Our website may contain links to third-party websites, including LinkedIn, YouTube, and other partner platforms. We are not responsible for the privacy practices of these sites and encourage you to review their respective privacy policies.`,
      },
      {
        title: "10. Changes to This Policy",
        body: `AutoNxt Automation Pvt. Ltd. reserves the right to update this Privacy Policy at any time. Any changes will be published on this page with an updated effective date. We encourage you to review this policy periodically.`,
      },
      {
        title: "11. Contact Us",
        body: `For any questions, concerns, or requests relating to this Privacy Policy or the AUTONXT-Attendance app, please contact:

AutoNxt Automation Pvt. Ltd.
704 & 705, Amfotech IT Park, Rd 8, Wagle Estate Rd,
Padwal Nagar, Thane West, Thane, Maharashtra 400604
Phone: +91 9067404606
Email: software-admin@autonxt.in
Google Play developer: autonxtdeveloper`,
      },
    ]
  },
  // Terms Page
  termsPage: {
    metaTitle: "Terms and Conditions | AutoNxt",
    metaDescription: "AutoNxt Automation Terms and Conditions of use.",
    texts: {
      legalBadge: "Legal",
      termsTitle: "Terms & Conditions",
      effectiveDate: "Effective date: 1 January 2025 · AutoNxt Automation Pvt. Ltd.",
      termsIntro: "Please read these Terms and Conditions carefully before using the AutoNxt website. By accessing this site, you acknowledge that you have read, understood, and agree to be bound by these terms.",
      backToHome: "Back to Home",
      copyright: "© 2025 AutoNxt Automation Pvt. Ltd. All rights reserved.",
    },
    sections: [
      {
        title: "1. Acceptance of Terms",
        body: `By accessing or using the AutoNxt website (autonxt.in) and any associated services, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, you must not use our website or services. These terms apply to all visitors, users, and customers of AutoNxt Automation Pvt. Ltd.`,
      },
      {
        title: "2. About AutoNxt",
        body: `AutoNxt Automation Pvt. Ltd. is a company incorporated under the Companies Act, 2013, with its registered office at:\n\n704 & 705, Amfotech IT Park, Rd 8, Wagle Estate Rd,\nPadwal Nagar, Thane West, Thane, Maharashtra 400604\nCIN: [U29301MH2016PTC XXXXXX]\nGSTIN: [27XXXXX]`,
      },
      {
        title: "3. Use of the Website",
        body: `You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of others. You must not:\n• Use the site in any way that violates applicable local, national, or international law or regulation.\n• Transmit unsolicited promotional material or spam.\n• Attempt to gain unauthorised access to any part of the website or its related systems.\n• Reproduce, duplicate, copy, or re-sell any part of this website without our express written consent.\n\nAutoNxt reserves the right to suspend or restrict access to the website for any user who violates these conditions.`,
      },
      {
        title: "4. Product Information and Pricing",
        body: `All product specifications, performance figures, and pricing shown on this website are indicative and subject to change without notice. Final pricing, delivery timelines, and warranty terms will be confirmed in writing at the time of order. AutoNxt reserves the right to withdraw or modify any product, offer, or specification at any time.`,
      },
      {
        title: "5. Demo Bookings and Enquiries",
        body: `Submitting a demo booking or product enquiry through this website does not constitute a binding contract or purchase order. All bookings are subject to availability and confirmation by an AutoNxt representative. AutoNxt reserves the right to decline any booking request at its discretion.`,
      },
      {
        title: "6. Intellectual Property",
        body: `All content on this website — including but not limited to text, images, graphics, logos, videos, and software — is the intellectual property of AutoNxt Automation Pvt. Ltd. or its licensors, and is protected by applicable Indian and international intellectual property laws. You may not use, reproduce, or distribute any content without prior written permission from AutoNxt.`,
      },
      {
        title: "7. Disclaimers and Limitation of Liability",
        body: `This website and its content are provided "as is" without any warranties, express or implied. AutoNxt does not warrant that the website will be error-free, uninterrupted, or free of viruses or other harmful components.\n\nTo the maximum extent permitted by applicable law, AutoNxt shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of this website or our products and services.`,
      },
      {
        title: "8. Third-Party Links",
        body: `This website may contain links to external websites operated by third parties. These links are provided for convenience only. AutoNxt does not endorse, and is not responsible for, the content or practices of any linked third-party websites.`,
      },
      {
        title: "9. Governing Law and Jurisdiction",
        body: `These Terms and Conditions are governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in Thane, Maharashtra.`,
      },
      {
        title: "10. Amendments",
        body: `AutoNxt reserves the right to modify these Terms and Conditions at any time. Updated terms will be posted on this page with a revised effective date. Continued use of the website following any changes constitutes your acceptance of the revised terms.`,
      },
      {
        title: "11. Contact",
        body: `For any questions regarding these Terms and Conditions:\n\nAutoNxt Automation Pvt. Ltd.\n704 & 705, Amfotech IT Park, Rd 8, Wagle Estate Rd,\nPadwal Nagar, Thane West, Thane, Maharashtra 400604\nPhone: +91 9067404606\nEmail: sales@autonxt.in`,
      },
    ]
  },
  accountDeletionPage: {
    metaTitle: "Account & Data Deletion — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "User Data",
      pageTitle: "Account & Data Deletion — AUTONXT-Attendance",
      pageSubtitle:
        "Request deletion of your AUTONXT-Attendance app account and associated personal data.",
      metaDescription:
        "Delete your AUTONXT-Attendance account (com.autonxt.attendance.app2). Official account deletion page by AutoNxt Automation Pvt. Ltd. (autonxtdeveloper).",
      effectiveDate: "Effective date: 18 June 2025 · AutoNxt Automation Pvt. Ltd.",
      pageIntro:
        'AutoNxt Automation Pvt. Ltd. ("AutoNxt"), developer of the AUTONXT-Attendance mobile application (package: com.autonxt.attendance.app2, Google Play developer: autonxtdeveloper), provides this page for app users who wish to delete their account and associated personal data. This page explains how to submit a deletion request, what data is removed, and what data may be retained as required by law.',
      requestTitle: "How to request AUTONXT-Attendance account deletion",
      requestButton: "Email deletion request",
      requestMailto:
        "mailto:software-admin@autonxt.in?subject=AUTONXT-Attendance%20-%20Account%20Deletion%20Request&body=Please%20delete%20my%20AUTONXT-Attendance%20app%20account%20and%20associated%20data.%0A%0AApp%3A%20AUTONXT-Attendance%20(com.autonxt.attendance.app2)%0ARegistered%20email%20/%20phone%3A%20%0AEmployee%20ID%20(if%20any)%3A%20%0AAccount%20username%20(if%20any)%3A%20%0AReason%20(optional)%3A%20",
      processingNote:
        "We typically process verified deletion requests within 30 days. You will receive a confirmation email once your AUTONXT-Attendance account and eligible data have been deleted.",
      deletedTitle: "Data that will be deleted",
      retainedTitle: "Data that may be retained",
      privacyLinkTitle: "Privacy Policy",
      privacyLinkDesc: "Read the AUTONXT-Attendance privacy policy for details on how we collect and use data.",
      privacyLinkButton: "View Privacy Policy",
      backToHome: "Back to Home",
      copyright: "© 2025 AutoNxt Automation Pvt. Ltd. All rights reserved.",
    },
    steps: [
      "Send an email to software-admin@autonxt.in from the email address linked to your AUTONXT-Attendance app account.",
      "Use the subject line: AUTONXT-Attendance - Account Deletion Request.",
      "Include your registered email address, phone number, employee ID, and account username (if applicable) so we can verify your identity.",
      "Our team will verify your request and delete your AUTONXT-Attendance account along with associated personal data.",
      "You will receive a confirmation email once the deletion is complete.",
    ],
    deletedItems: [
      "Your AUTONXT-Attendance account profile (name, email, phone number, employee ID, and login credentials)",
      "Attendance records linked to your account (check-in/check-out history, shift data, and attendance status)",
      "User preferences and app settings",
      "Push notification tokens and device identifiers used for app notifications",
      "Location data associated with your attendance check-ins (where applicable)",
      "Chat or support conversation history associated with your account",
    ],
    retainedItems: [
      "Anonymised or aggregated attendance analytics that cannot identify you personally",
      "Records your employer or organisation is legally required to retain for payroll, tax, or labour compliance (retained as required by applicable law, typically up to 7 years)",
      "Records we are legally required to retain under Indian law or a valid court/regulatory order",
      "Backup copies may persist for up to 90 days after deletion before being permanently removed from all systems",
    ],
    sections: [
      {
        title: "In-app deletion (where available)",
        body: "If your version of the AUTONXT-Attendance app includes an in-app account deletion option, you may also delete your account from:\n\nApp → Profile / Settings → Account → Delete Account\n\nIf this option is not visible in your app version, please use the email request process described above.",
      },
      {
        title: "Identity verification",
        body: "To protect your account, we may ask you to confirm ownership of the registered email address or phone number before processing a deletion request. We will not delete an AUTONXT-Attendance account based on an unverified third-party request.",
      },
      {
        title: "Processing timeline",
        body: "Verified AUTONXT-Attendance account deletion requests are processed within 30 days. During this period, your account may be deactivated immediately, but complete removal from all backups and systems may take up to 90 days.",
      },
      {
        title: "Contact us",
        body: "For AUTONXT-Attendance account deletion requests or questions about your personal data:\n\nAutoNxt Automation Pvt. Ltd.\nDeveloper of AUTONXT-Attendance (com.autonxt.attendance.app2)\nGoogle Play developer: autonxtdeveloper\n704 & 705, Amfotech IT Park, Rd 8, Wagle Estate Rd,\nPadwal Nagar, Thane West, Thane, Maharashtra 400604\nPhone: +91 9067404606\nEmail: software-admin@autonxt.in",
      },
    ],
  },
  // NotFound Page
  notFoundPage: {
    title: "404 Page Not Found",
    desc: "Did you forget to add the page to the router?",
  },
  attachmentDetailPage: {
    availableNow: "Available Now",
    productNotFound: "Product Not Found",
    backToProducts: "Back To Products",
    interactiveModel: "Interactive Model",
    preview3D: "3D Preview",
    loadingModel: "Loading 3D Model...",
    specifications: "Specifications",
    technicalDetails: "Technical Details",
    whyChoose: "Why Choose This Product",
    features: "Features",
    quoteBtn: "Request Quote",
    bookBtn: "Book Demo",
    stats: {
      support: "Support",
      supportVal: "24/7",
      availability: "Availability",
      availabilityVal: "Pan India",
      response: "Response",
      responseVal: "< 24H"
    },
    attachments: {
      bucket: {
        name: "18 Feet Graber Bucket",
        type: "Heavy Duty Implement",
        badge: "Heavy Duty",
        tagline: "Maximum Digging Power for Any Terrain",
        desc: "Heavy-duty 18 feet graber bucket attachment designed for efficient material handling and excavation operations. Built with premium materials and advanced engineering for maximum durability and performance in demanding construction and agricultural environments.",
        specs: {
          width: "18 Feet",
          capacity: "0.8m³",
          material: "Hardox 450",
          weight: "480kg",
          power: "45 kW",
          battery: "50 kWh",
          runtime: "6-8 hours",
          charging: "4-5 hours",
          widthLabel: "Width",
          capacityLabel: "Capacity",
          materialLabel: "Material",
          weightLabel: "Weight",
          powerLabel: "Power",
          batteryLabel: "Battery",
          runtimeLabel: "Run Time",
          chargingLabel: "Charging"
        },
        features: [
          { title: "Hardox Steel", desc: "Extreme wear resistance for long-term durability in rugged environments." },
          { title: "Universal Hitch", desc: "Compatible with all AutoNxt tractor platforms." },
          { title: "Quick Release Teeth", desc: "Replaceable teeth system for easy maintenance." }
        ],
        highlights: [
          "Heavy Duty Design",
          "Zero Emission Compatible",
          "3 Point Hitch",
          "Industrial Grade Steel",
          "Fast Maintenance",
          "Made For Bharat"
        ]
      },
      catcher: {
        name: "18 Feet Catcher",
        type: "Precision Implement",
        badge: "Precision",
        tagline: "Efficient Material Collection and Harvesting",
        desc: "Precision-engineered 18 feet catcher attachment designed for efficient material collection and handling operations. Features advanced hydraulic controls and durable construction for optimal performance in agricultural and industrial applications. Ideal for harvesting, material sorting, and specialized collection tasks with enhanced precision and reliability. Built with premium materials and state-of-the-art engineering to deliver consistent performance in demanding environments.",
        specs: {
          width: "18 Feet",
          capacity: "0.75m³",
          material: "Hardox 400",
          weight: "450kg",
          power: "40 kW",
          battery: "45 kWh",
          runtime: "5-7 hours",
          charging: "3-4 hours",
          widthLabel: "Width",
          capacityLabel: "Capacity",
          materialLabel: "Material",
          weightLabel: "Weight",
          powerLabel: "Power",
          batteryLabel: "Battery",
          runtimeLabel: "Run Time",
          chargingLabel: "Charging"
        },
        features: [
          { title: "Precision Engineering", desc: "Optimized design for accurate material collection and minimal spillage." },
          { title: "Universal Hitch", desc: "Compatible with all AutoNxt tractor platforms." },
          { title: "Easy Maintenance", desc: "Simplified maintenance design for quick servicing." }
        ],
        highlights: [
          "Precision Design",
          "Zero Emission Compatible",
          "3 Point Hitch",
          "Optimized Capacity",
          "Easy Maintenance",
          "Made For Bharat"
        ]
      },
      loader: {
        name: "18 Feet Loader Bucket",
        type: "Max Load Implement",
        badge: "Max Load",
        tagline: "Maximum Efficiency in Loading and Material Transport",
        desc: "Heavy-duty 18 feet loader bucket engineered for maximum efficiency in loading and material transport operations. Built with superior strength materials and advanced hydraulic systems for handling the most demanding construction, mining, and agricultural tasks. Features optimized bucket geometry for enhanced material retention and efficient loading cycles. Designed to withstand extreme working conditions while maintaining peak performance and operational reliability.",
        specs: {
          width: "18 Feet",
          capacity: "0.9m³",
          material: "Hardox 500",
          weight: "520kg",
          power: "50 kW",
          battery: "55 kWh",
          runtime: "7-9 hours",
          charging: "4-6 hours",
          widthLabel: "Width",
          capacityLabel: "Capacity",
          materialLabel: "Material",
          weightLabel: "Weight",
          powerLabel: "Power",
          batteryLabel: "Battery",
          runtimeLabel: "Run Time",
          chargingLabel: "Charging"
        },
        features: [
          { title: "Maximum Capacity", desc: "Engineered for maximum load capacity and durability in heavy operations." },
          { title: "Universal Hitch", desc: "Compatible with all AutoNxt tractor platforms." },
          { title: "Reinforced Structure", desc: "Extra reinforcement for handling maximum loads safely." }
        ],
        highlights: [
          "Maximum Capacity",
          "Zero Emission Compatible",
          "3 Point Hitch",
          "Reinforced Steel",
          "Heavy Duty Design",
          "Made For Bharat"
        ]
      }
    }
  },
  aboutPage: {
    aboutAutoNxt: "About AutoNxt",
    foundedLabel: "Founded",
    headquarteredLabel: "Headquartered",
    teamSizeLabel: "Team Size",
    foundedInMumbai: "Founded in Mumbai",
    connectLinkedIn: "Connect on LinkedIn",
    ourJourney: "Our Journey",
    fromConcept: "From Concept to Market Leader.",
    team: [
      { name: "Kaustubh Dhonde", role: "Chief Executive Officer", bio: "Visionary leader driving AutoNxt's mission to revolutionize agriculture with innovative electric vehicle solutions." },
      { name: "Pankaj Goyal", role: "Co-Founder & COO", bio: "Operational strategist ensuring seamless execution and growth, overseeing day-to-day operations and partnerships." },
      { name: "Gaurav Borkar", role: "Chief Financial Officer", bio: "Seasoned finance professional and strategic business leader driving financial strategy, fundraising, and corporate governance." },
      { name: "Amit Kumar Shivhare", role: "Head – Accounts & Finance", bio: "Senior Accounts & Finance Leader with 15+ years of progressive experience driving financial strategy, governance and business performance." },
      { name: "Pratik", role: "Head of FP&A", bio: "Chartered Accountant leading corporate finance, FP&A, fundraising modelling, and strategic financial governance." },
      { name: "Hari Kishan", role: "Plant Head", bio: "Oversees plant operations, ensuring quality and efficiency in every tractor produced." },
      { name: "Sudipto Deb", role: "Lead Power Train Engineer", bio: "Expert in power electronics, responsible for designing and optimizing the electrical systems powering our tractors." },
      { name: "Vamsi Atluri", role: "Lead Mechanical Design Engineer", bio: "Mechanical design innovator, crafting robust and efficient tractor structures for diverse agricultural needs." },
      { name: "Dr. Dharmateja Adapa", role: "Lead Robotics Engineer", bio: "Automation expert focused on integrating smart technologies for seamless and reliable tractor performance." },
      { name: "Tejesh Madireddy", role: "Lead Embedded Engineer", bio: "Leads embedded systems development, ensuring reliable and efficient hardware-software integration." },
      { name: "Aswanth Mulupuri", role: "Robotics & Automation Engineer", bio: "Specialist in automation, developing advanced control systems for autonomous tractor operation." },
      { name: "Ajinkya Delvi", role: "Power Train Engineer", bio: "Works on power train systems, optimizing performance and efficiency." },
      { name: "Khushpreet Singh", role: "Testing & Validation Engineer", bio: "Responsible for rigorous testing and validation, guaranteeing the reliability and safety of our products." },
      { name: "Swapnesh Jahagirdar", role: "Business Development Manager", bio: "Focused on identifying new opportunities and fostering relationships to accelerate company expansion." }
    ],
    advisors: [
      { name: "IV-Rao", role: "Senior Advisor", bio: "Together, we challenge ourselves for a better tomorrow through meaningful designs and lasting relevance." },
      { name: "Ashish Mehta", role: "Financial Advisor", bio: "Contemporary design and well-made products are things that everyone should benefit from — driving what we do." },
      { name: "Swadeep Pillarisetti", role: "Strategy Consultant", bio: "Our collection is ever-evolving yet consistently relatable. Our purpose is to inspire and help showcase the look you want." }
    ],
    journey: [
      { year: "2016", title: "Foundation", desc: "AutoNxt Automation Pvt. Ltd. was founded by Kaustubh Dhonde in Mumbai with a vision to revolutionize agriculture and industrial operations through electric and autonomous tractors." },
      { year: "2018–19", title: "Research & Early Prototypes", desc: "Extensive R&D on high-torque electric powertrains and intelligent control systems. AutoNxt successfully built and tested early prototypes, proving the feasibility of replacing diesel with electric technology." },
      { year: "2020–21", title: "Innovation & Development", desc: "Enhanced prototypes with smarter vehicle control units and IoT-based monitoring. Expanded the engineering team and strengthened partnerships for component development and testing." },
      { year: "2022–23", title: "Validation & Certification", desc: "Electric tractors underwent rigorous performance and safety testing. Received certifications from iCAT (International Centre for Automotive Technology), finalizing 20 HP, 35 HP, and 45 HP variants." },
      { year: "2024", title: "Commercial Launch", desc: "AutoNxt officially launched the X45H2 in Thane, Maharashtra. First unit delivered to Jaywant Sugars Ltd. — establishing AutoNxt as India's pioneer in the electric tractor ecosystem." },
      { year: "2025+", title: "Growth & Expansion", desc: "Expanding production capabilities and customer base across agricultural and industrial sectors. Advancing autonomous driving, smart connectivity, and next-generation battery systems." }
    ],
    process: [
      { step: "01", title: "Define", desc: "Define requirements for the electric self-driving tractors — gathering field insights and engineering constraints." },
      { step: "02", title: "Design", desc: "Create 3D models and schematics, select components such as motor, battery, and sensors, and design the autonomous driving system." },
      { step: "03", title: "Develop", desc: "Build physical components including the chassis, motor, battery, sensors, and autonomous driving system." },
      { step: "04", title: "Test", desc: "Test performance in a variety of conditions — different terrains, weather conditions, and driving scenarios across India." },
      { step: "05", title: "Refine", desc: "Based on test results, adjust components, fine-tune software algorithms, or make changes to the user interface." },
      { step: "06", title: "Manufacture", desc: "Set up the manufacturing process, source components, and develop a distribution network for scale." }
    ],
    values: [
      { title: "Customer First", desc: "We prioritize our customers' needs and satisfaction above all else." },
      { title: "Innovation", desc: "Constantly pushing boundaries in electric vehicle technology." },
      { title: "Excellence", desc: "Committed to delivering the highest quality products and services." },
      { title: "Sustainability", desc: "Dedicated to creating a greener future for agriculture." }
    ]
  },
  galleryPage: {
    galleryPhotos: "Photos",
    galleryVideos: "Videos",
    galleryEvents: "Events",
    eventHandoverTitle: "Official Government Handover Ceremony",
    eventHandoverDesc: "June 29, 2025 — AutoNxt delivered the X45H2 electric tractor at an official ceremony attended by government officials, police representatives, and media. A landmark moment in AutoNxt's journey to serve India's public institutions.",
    photos: [
      { alt: "First consignment of AutoNxt electric tractors prepared for commercial dispatch", label: "First Consignment Dispatch", tag: "In the Field" },
      { alt: "AutoNxt electric tractors loaded on a transport truck for delivery", label: "Tractors Loaded for Delivery", tag: "In the Field" },
      { alt: "AutoNxt electric tractors consignment ready for transport", label: "Consignment Transit", tag: "In the Field" },
      { alt: "AutoNxt electric tractor displayed at Krishithon 2023 exhibition in Nashik", label: "Krishithon 2023 — Nashik Showcase", tag: "In the Field" },
      { alt: "AutoNxt electric tractor loader demonstration at Krishithon 2023", label: "Krishithon 2023 — Loader Demo", tag: "In the Field" },
      { alt: "Autonxt X45H2 with Commercial Trailer", label: "X45H2 — Commercial Hauling", tag: "Industrial" }
    ],
    events: [
      { alt: "AutoNxt X45H2 launch ceremony with officials and media", label: "Official Launch Address — Jun 29, 2025", tag: "Event" },
      { alt: "MOU signing ceremony — AutoNxt tractor handover", label: "Handover Ceremony & MOU Signing", tag: "Event" },
      { alt: "Officials blessing the AutoNxt X45H2 electric tractor", label: "X45H2 Inauguration Ceremony", tag: "Event" },
      { alt: "Dignitaries and team gathered around the AutoNxt X45H2", label: "X45H2 — Official Blessing", tag: "Event" },
      { alt: "AutoNxt X45H2 tractor surrounded by guests during ceremony", label: "X45H2 — Flag-Off Ceremony", tag: "Event" },
      { alt: "Tricolour balloon arch and X45H2 display at event", label: "Tricolour Launch Stage — Jun 29, 2025", tag: "Event" },
      { alt: "Close-up of AutoNxt X45H2 electric tractor at launch event", label: "AutoNxt X45H2 — Up Close", tag: "Product" }
    ],
    videos: [
      { title: "AutoNxt X45H2 Electric Tractor — Product Description (English)", desc: "Full product walkthrough of AutoNxt's flagship 45HP electric tractor — the X45H2 — covering specs, features, and capabilities." },
      { title: "X45H2 — Rotavator Puddling in Heavy Rains & Flooded Farms", desc: "Watch the X45H2 tackle rotavator puddling operations in heavy rainy season and completely flooded farm conditions." },
      { title: "First Electric Tractor of Maharashtra Delivered to Jaywant Sugar Mill", desc: "Historic delivery of the first AutoNxt electric tractor to Jaywant Sugar Mill, Karad, Satara — a landmark for Indian agri-EV." },
      { title: "AutoNxt 45HP Electric Tractor — Full Power Demo", desc: "See the X45H2 demonstrating its full torque and performance capabilities across multiple field operations." },
      { title: "X45H2 — Haulage, Tiller, Reaper & Water Jet Wash", desc: "Comprehensive field demonstration of the X45H2 performing haulage, tilling, reaping operations and a thorough water jet wash." },
      { title: "AutoNxt X45H2 इलेक्ट्रिक ट्रैक्टर — उत्पाद विवरण (हिंदी में)", desc: "हिंदी में AutoNxt X45H2 इलेक्ट्रिक ट्रैक्टर का पूरा उत्पाद विवरण — भारतीय किसानों के लिए।" }
    ]
  },
  blogPage: {
    postsLabel: "Posts",
    postsValue: "20+",
    authorsLabel: "Authors",
    authorsValue: "6",
    topicsLabel: "Topics",
    posts: [
      {
        tag: "Technology",
        title: "Revolutionizing Indian Agriculture: AutoNxt's Electric Tractors Bring Intelligence, Sustainability, and Profitability to Farmers",
        author: "The India Wire Network",
        date: "August 2025",
        readTime: "4 min read",
        image: "/images/x45h2Image2.webp",
        summary: "In an exclusive interview with Kaustabh Dhonde, Founder and CEO of AutoNxt Automation, and Pankaj Goyal, Co-founder and COO, share how their company is pioneering the electric tractor revolution in India — from cutting farmers' diesel dependence to integrating AI, IoT, and telematics for smarter operations.",
        externalUrl: "https://theindiawire.com/india/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers/",
        featured: true
      },
      {
        tag: "Autonomous Technology",
        title: "Building India's First Ever Self-Driving Tractor",
        author: "Insiders Talk",
        date: "December 2024",
        readTime: "6 min read",
        image: "/images/videos/driverless-tractor-thumbnail.webp",
        summary: "AutoNxt is at the forefront of developing autonomous farming technology, creating India's first self-driving tractor. The development offers farmers increased efficiency, reduced labor costs, and improved precision in farming operations.",
        externalUrl: "https://insiderstalk.in/building-indias-first-ever-self-driving-tractor/",
        featured: false
      },
      {
        tag: "Future Technology",
        title: "Future of Farming: India's First Self-Driving Tractor",
        author: "Tractor Junction",
        date: "November 2024",
        readTime: "8 min read",
        image: "/images/blog/future-of-farming.webp",
        summary: "AutoNxt Automation is pioneering the future of farming with India's first autonomous electric tractor, combining cutting-edge technology with sustainable agriculture and offering unprecedented control and efficiency.",
        externalUrl: "https://www.tractorjunction.com/tractor-news/future-of-farming-india-first-self-driving-tractor/",
        featured: false
      },
      {
        tag: "Agricultural Technology",
        title: "AutoNxt Tractor: Revolutionizing Agriculture with Electric and Autonomous Technology",
        author: "Tractor Guru",
        date: "October 2024",
        readTime: "9 min read",
        image: "/images/blog/autonxt-tractor-revolutionizing-agriculture.webp",
        summary: "Comprehensive coverage of AutoNxt's innovative tractor solutions — electric tractors, autonomous driving capabilities, and smart farming solutions that address the evolving needs of modern agriculture in India and beyond.",
        externalUrl: "https://tractorguru.in/blog/category/autonxt-tractor/",
        featured: false
      },
      {
        tag: "Company Profile",
        title: "AutoNxt Automation: Pioneering Electric and Autonomous Agricultural Solutions",
        author: "Tracxn Research Team",
        date: "September 2024",
        readTime: "7 min read",
        image: "/images/blog/game-changing-electric-tractor.webp",
        summary: "Detailed company profile and analysis of AutoNxt Automation's innovative approach to sustainable agriculture. AutoNxt has established itself as a leader in agricultural innovation, combining environmental sustainability with cutting-edge technology.",
        externalUrl: "https://tracxn.com/d/companies/autonxt-automation/__ZSsZ4cr50wm63YgF4zOMI1CcYVW2V43yS-5Lojtdze0",
        featured: false
      },
      {
        tag: "Company Profile",
        title: "Kaustubh Dhonde: Story of AutoNxt Automation, Pioneering Electric and Autonomous Agricultural Solutions",
        author: "SugerMint",
        date: "May 2024",
        readTime: "5 min read",
        image: "/images/blog/kaustubh-dhonde-story.webp",
        summary: "An inspiring interview with Kaustubh Dhonde, Founder & CEO of AutoNxt Automation, sharing his personal motivations, the challenges of starting an EV brand in India, and the development of the country's first autonomous electric tractor.",
        externalUrl: "https://sugermint.com/kaustubh-dhonde/",
        featured: false
      },
      {
        tag: "Industry News",
        title: "AutoNxt Automation To Launch An Electric - Self Driving Tractor",
        author: "BW Online Bureau",
        date: "August 2022",
        readTime: "3 min read",
        image: "/images/blog/autonxt-bw-autoworld.webp",
        summary: "Electric tractor venture startup AutoNxt Automation is set to launch its 20HP, 35HP, and 45HP electric tractor variants in the market, introducing production-ready high-torque electric powertrains and preparing autonomous driving features.",
        externalUrl: "https://bwautoworld.com/article/autonxt-automation-to-launch-an-electric-self-driving-tractor-442543",
        featured: false
      }
    ]
  },
  evBlogPage: {
    articlesLabel: "Articles",
    articlesValue: "7 Tech Guides",
    topicsLabel: "Key Focus",
    topicsValue: "5 Categories",
    avgReadLabel: "Avg Read",
    avgReadValue: "6 Minutes",
    categories: ["All", "Battery Tech", "Policy & Incentives", "Market Trends", "Future Tech"],
    articles: [
      {
        cat: "Sustainability",
        title: "The Rise of Eco-Friendly Tractors in India's Push for Green Growth",
        date: "January 2025",
        readTime: "6 min",
        image: "/images/blog/future-of-farming.webp",
        summary: "India is witnessing a significant transformation in its agricultural sector with the emergence of eco-friendly electric tractors, aligning with the nation's ambitious green growth initiatives and its commitment to sustainable development and carbon neutrality.",
        externalUrl: "https://www.theautomonitor.com/the-rise-of-eco-friendly-tractors-in-indias-push-for-green-growth/",
        featured: true
      },
      {
        cat: "Innovation",
        title: "Bridging Sustainability and Productivity with Electric Tractor Technology",
        date: "November 2025",
        readTime: "7 min",
        image: "/images/blog/bridging-sustainability.webp",
        summary: "Electric tractor technology is revolutionizing agriculture by combining environmental sustainability with enhanced productivity, offering farmers a viable path to more efficient and profitable farming operations — proving that environmental responsibility and operational efficiency can go hand in hand.",
        externalUrl: "https://emobilityplus.com/2025/11/17/opinion-bridging-sustainability-and-productivity-with-electric-tractor-technology/",
        featured: true
      },
      {
        cat: "Revolution",
        title: "How Electric Tractors Are Powering a Sustainable Revolution in Indian Agriculture",
        date: "January 2025",
        readTime: "5 min",
        image: "/images/blog/sustainable-revolution.webp",
        summary: "Electric tractors are driving a sustainable agricultural revolution across India, empowering farmers with clean, efficient, and cost-effective alternatives to traditional diesel-powered machinery and addressing both environmental and economic challenges.",
        externalUrl: "https://republicnewsindia.com/how-electric-tractors-are-powering-a-sustainable-revolution-in-indian-agriculture/",
        featured: false
      },
      {
        cat: "Future Technology",
        title: "Farming Without Fumes: Why Electric Tractors Are the Future of Indian Agriculture",
        date: "February 2025",
        readTime: "8 min",
        image: "/images/blog/farming-without-fumes.webp",
        summary: "Electric tractors represent the future of Indian agriculture, eliminating harmful emissions while delivering superior performance and reducing operational costs for farmers nationwide — a clean, efficient path forward for the farming community.",
        externalUrl: "https://www.thehindubusinessline.com/economy/agri-business/farming-without-fumes-why-electric-tractors-are-the-future-of-indian-agriculture/article70202273.ece",
        featured: false
      },
      {
        cat: "Battery Tech",
        title: "Innovative Battery Technologies Powering the Next Generation of Electric Tractors",
        date: "July 2024",
        readTime: "6 min",
        image: "/images/blog/innovative-battery-tech.webp",
        summary: "Explores how electric tractors are emerging as a pivotal solution in sustainable agriculture, driven by innovative battery technologies, modular systems, and hydrogen fuel cells.",
        externalUrl: "https://www.theautomonitor.com/innovative-battery-technologies-powering-the-next-generation-of-electric-tractors/",
        featured: false
      },
      {
        cat: "Policy & Incentives",
        title: "Government Policies and Subsidies Driving the Adoption of Electric Tractors",
        date: "January 2025",
        readTime: "6 min",
        image: "/images/blog/government-policies.webp",
        summary: "Discusses how supportive government policies, subsidies, and global sustainability initiatives are driving the transition of the agricultural sector toward eco-friendly electric tractors.",
        externalUrl: "https://www.theautomonitor.com/government-policies-and-subsidies-driving-the-adoption-of-electric-tractors/",
        featured: false
      },
      {
        cat: "Market Trends",
        title: "Why 2026 Could Be the Turning Point for Electric Tractors in Indian Agriculture",
        date: "January 2026",
        readTime: "4 min",
        image: "/images/blog/why-2026-turning-point.webp",
        summary: "Highlights how upcoming policy shifts, battery cost reductions, and technical improvements could make 2026 a milestone year for electric tractor adoption in India.",
        externalUrl: "https://www.theautomonitor.com/why-2026-could-be-the-turning-point-for-electric-tractors-in-indian-agriculture/",
        featured: false
      }
    ],
    authorRoleLabel: "Publication",
    stats: [
      { value: "38%", label: "Market CAGR 2024–27" },
      { value: "₹4,000 Cr", label: "India EV Tractor TAM by 2027" },
      { value: "70%", label: "Lower running costs vs diesel" },
      { value: "0", label: "Direct CO₂ emissions" }
    ]
  },
  newsPage: {
    storiesLabel: "Stories",
    storiesValue: "50+",
    coverageLabel: "Publishers",
    coverageValue: "National",
    milestonesLabel: "Categories",
    milestonesValue: "6 Key",
    readMore: "Read More",
    news: [
      {
        date: "6/18/2026",
        tag: "Award",
        title: "AutoNxt Automation Wins First-Ever 'Electric Tractor of the Year' Award at ITOTY 2026",
        summary: "AutoNxt Automation has become the first-ever winner of the 'Electric Tractor of the Year' award at the Indian Tractor of the Year (ITOTY) Awards 2026, marking a historic milestone for India's electric farm machinery industry.",
        author: "AutoNxt Team",
        readTime: "3 min read",
        image: "/images/linkedin/linkedin-post-1.webp",
        externalUrl: "https://www.linkedin.com/posts/autonxt-automation_autonxt-itoty2026-electrictractoroftheyear-activity-7473003691902451712-w4BZ?utm_source=share&utm_medium=member_desktop&rcm=ACoAACrujPEBnx6l4DUGYojLDsLzMTTIYS7FTxk"
      },
      {
        date: "11/10/2024",
        tag: "Event",
        title: "AutoNxt Showcases Electric Tractor at Delhi EV Rally 'BREATHE' Flagged off by Minister Manohar Lal Khattar",
        summary: "AutoNxt was the sole Electric Tractor present at CESL's prestigious EV rally, BREATHE, in Delhi. Power Minister Shri Manohar Lal Khattar took a ride on our tractor and praised its smooth performance.",
        author: "AutoNxt Team",
        readTime: "3 min read",
        image: "/images/events/event-1.webp",
        externalUrl: "https://www.linkedin.com/company/autonxt-automation"
      },
      {
        date: "4/10/2024",
        tag: "Product Launch",
        title: "AutoNxt Automation Set to Launch India's First Self-Driving Electric Tractor",
        summary: "AutoNxt unveils India's first self-driving electric tractor, advancing sustainable farming and commercial sectors with innovative technology and funding support.",
        author: "Robin Kumar Attri",
        readTime: "5 min read",
        externalUrl: "https://www.cmv360.com/tractors/news/autonxt-automation-launching-india-first-self-driving-electric-tractor"
      },
      {
        date: "4/9/2024",
        tag: "Funding",
        title: "AutoNxt Automation secures Pre-Series A funding led by Saama",
        summary: "AutoNxt is set to launch India's first electric tractor with self-driving options, designed for commercial use in various sectors.",
        author: "Online Bureau",
        readTime: "2 min read",
        externalUrl: "https://auto.economictimes.indiatimes.com/news/automotive/autonxt-automation-secures-pre-series-a-funding-led-by-saama/109165048"
      },
      {
        date: "4/10/2024",
        tag: "Funding",
        title: "AutoNxt Automation To Introduce India's First Self-Driving Electric Tractor, Secures Pre-Series A Funding",
        summary: "AutoNxt Automation has successfully concluded its Pre-Series A funding round led by Saama, gearing up to introduce India's first electric tractor with self-driving capabilities.",
        author: "Suneha Mishra",
        readTime: "4 min read",
        externalUrl: "https://tractornews.in/news/autonxt-automation-to-introduce-india-s-first-self-driving-electric-tractor-secures-pre-series-a-funding/"
      },
      {
        date: "4/9/2024",
        tag: "Funding",
        title: "AutoNxt Automation Secures Pre-Series A Funding From Saama",
        summary: "AutoNxt Automation secures significant funding to accelerate development of India's first self-driving electric tractor for commercial applications.",
        author: "Tractor Junction",
        readTime: "3 min read",
        externalUrl: "https://www.tractorjunction.com/tractor-news/autonxt-automation-secures-pre-series-a-funding-from-saama/"
      },
      {
        date: "4/9/2024",
        tag: "Funding",
        title: "AutoNxt Secures Pre-Series A Funding for Electric Autonomous Tractor Development",
        summary: "AutoNxt Automation secures Pre-Series A funding to advance development of electric autonomous tractors for commercial and agricultural applications.",
        author: "Mercom India",
        readTime: "3 min read",
        externalUrl: "https://www.mercomindia.com/autonxt-pre-series-a-funding"
      },
      {
        date: "4/10/2024",
        tag: "Innovation",
        title: "AutoNxt's Game-Changing Electric Tractor Set to Transform Farming and Industry in India",
        summary: "AutoNxt's revolutionary electric tractor with self-driving capabilities is set to transform farming and industrial operations across India.",
        author: "Ahmedabad Mirror",
        readTime: "4 min read",
        externalUrl: "https://www.ahmedabadmirror.com/autonxts-game-changing-electric-tractor-set-to-transform-farming-and-industry-in-india/81891265.html"
      },
      {
        date: "4/10/2024",
        tag: "Agriculture",
        title: "Revolutionizing Indian Agriculture: AutoNxt's Electric Tractors Bring Intelligence, Sustainability and Profitability to Farmers",
        summary: "AutoNxt's electric tractors are revolutionizing Indian agriculture by bringing intelligence, sustainability and profitability to farmers across the country.",
        author: "First India",
        readTime: "5 min read",
        externalUrl: "https://firstindia.co.in/news/press-releases/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers"
      },
      {
        date: "4/9/2024",
        tag: "Funding",
        title: "AutoNxt Automation Secures Pre-Series A Funding for Electric Autonomous Tractor",
        summary: "AutoNxt Automation secures Pre-Series A funding to advance development of electric autonomous tractors for sustainable farming solutions.",
        author: "EV Reporter",
        readTime: "3 min read",
        externalUrl: "https://evreporter.com/autonxt-automation-secures-pre-series-a-funding-for-electric-autonomous-tractor/"
      },
      {
        date: "5/15/2024",
        tag: "Milestone",
        title: "AutoNxt Automation’s Electric Tractor Officially Registered at Thane RTO",
        summary: "AutoNxt Automation achieves a historic milestone as its 45HP electric tractor receives its first official commercial RTO vehicle registration in Thane, Maharashtra.",
        author: "SugerMint",
        readTime: "3 min read",
        externalUrl: "https://sugermint.com/autonxt-automation-electric-tractor/"
      }
    ]
  },

  // Dealer Page (Sales Partners)
  dealerPage: {
    metaTitle: "Sales Partners & Dealer Network | AutoNxt Electric Tractors",
    metaDescription: "Explore AutoNxt authorised sales partners, dealer profiles, work showcase across India, and apply to become an official AutoNxt Sales Partner.",
    badge: "Sales Partner Program",
    title: "Become an AutoNxt",
    titleHighlight: "Sales Partner",
    subtitle: "Join India's leading electric tractor revolution. Explore our nationwide sales partner network, dealer profiles, partner achievements, and apply to become an authorized sales & service partner.",
    mapSection: {
      badge: "Nationwide Network",
      title: "AutoNxt Market Presence Across India",
      subtitle: "Our authorized sales partners, experience centers, and 3S service hubs are operational across major agricultural and industrial centers.",
      stats: [
        { value: "25+", label: "Active Dealership Outlets" },
        { value: "15+", label: "States Covered" },
        { value: "100%", label: "3S Service Backing" },
        { value: "500+", label: "Charging Network Points" }
      ]
    },
    profilesSection: {
      badge: "Dealer Network",
      title: "Our Authorised Sales Partners & Work Showcase",
      subtitle: "Discover our trusted dealership profiles, regional coverage, and their landmark work in bringing electric tractors to Indian farms and industries.",
      searchPlaceholder: "Search by dealer name, city, state, or work...",
      filterAll: "All States",
      contactDealer: "Contact Partner",
      viewWork: "View Achievements",
    },
    benefits: {
      title: "Why Partner with AutoNxt?",
      subtitle: "Unlock exclusive advantages and grow with India's pioneering electric tractor brand.",
      items: [
        {
          title: "Exclusive Territory Rights",
          description: "Get dedicated regional sales rights with zero overlapping dealerships, ensuring maximum market potential in your territory."
        },
        {
          title: "Training & Certification",
          description: "Comprehensive product, technical, sales, and service training programs to equip your team with expert EV knowledge."
        },
        {
          title: "Marketing & Lead Support",
          description: "Co-branded marketing collateral, digital lead generation campaigns, and exhibition support to drive customers to your showroom."
        },
        {
          title: "High Margins & Incentives",
          description: "Attractive dealer margins on tractor sales, spare parts, and volume-based performance bonuses designed for high ROI."
        }
      ]
    },
    form: {
      title: "Apply to Become a Sales Partner",
      subtitle: "Fill out the application below and our partnership team will get in touch with you within 24–48 hours.",
      name: "Full Name",
      namePlaceholder: "Enter your full name",
      email: "Email Address",
      emailPlaceholder: "you@company.com",
      phone: "Phone Number",
      phonePlaceholder: "+91 98765 43210",
      company: "Business / Firm Name",
      companyPlaceholder: "Your firm or dealership name",
      city: "City / District",
      cityPlaceholder: "e.g. Satara, Nashik, Ludhiana",
      state: "State",
      statePlaceholder: "Select your state",
      experience: "Current Business / Dealership Experience",
      experiencePlaceholder: "e.g. 5+ years in auto / agri machinery sales",
      message: "Why do you want to become an AutoNxt Sales Partner?",
      messagePlaceholder: "Describe your showroom/workshop facility, team size, and commercial vision for EV tractors in your region...",
      submit: "Submit Sales Partner Application",
      submitting: "Submitting Application...",
      successTitle: "Sales Partner Application Submitted!",
      successMessage: "Thank you for your interest in partnering with AutoNxt. Our Sales Partner Onboarding team will review your application and contact you within 48 hours.",
      errorMessage: "Something went wrong while submitting. Please try again or contact us directly.",
      submitAnother: "Submit Another Application"
    },
    states: [
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
      "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
      "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
      "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
      "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
      "Uttar Pradesh", "Uttarakhand", "West Bengal",
      "Delhi", "Jammu & Kashmir", "Ladakh", "Puducherry", "Chandigarh"
    ],
    directory: {
      tag: "Authorized Network",
      title: "Authorized Dealers & Locations",
      subtitle: "Explore our verified network of AutoNxt authorized dealership centers, sales partners, and service hubs across India.",
      searchPlaceholder: "Search by dealer name, city, email, mobile or address...",
      allStates: "All States",
      dacNumber: "DAC Number",
      dealerName: "Dealer Name",
      email: "Dealer E-Mail",
      mobile: "Dealer Mobile",
      gstNo: "Dealer GST No",
      panNo: "Dealer PAN",
      address: "Address",
      noResults: "No authorized dealers found matching your search.",
      resetSearch: "Reset Filters",
      dealers: [
        {
          id: "8",
          dealerName: "One AK Next – Sales Partner, Maharashtra",
          address: "Maharashtra, India",
          state: "Maharashtra"
        },
        {
          id: "5",
          dealerName: "KISAN KALYAN ENTERPRISES",
          address: "SHOP 02, MORE HOUSE GROUND FLOOR, COURT AREA, OPP RAYMOND, BARH, PATNA, Bihar, Patna, 803213",
          state: "Bihar"
        }
      ]
    }
  },

  // Team Page
  teamPage: {
    metaTitle: "Our Team & Leadership | AutoNxt Electric Tractors",
    metaDescription: "Meet the engineers, innovators, and leaders driving India's first electric and autonomous tractor technology at AutoNxt Automation.",
    badge: "Our Innovators",
    title: "Meet the Minds Behind",
    titleHighlight: "AutoNxt",
    subtitle: "A multidisciplinary team of visionary leaders, mechanical engineers, powertrain experts, robotics specialists, and agricultural technologists electrifying Indian mobility.",
    stats: [
      { value: "150+", label: "Passionate Innovators" },
      { value: "10+", label: "Engineering Disciplines" },
      { value: "50+", label: "Patents & Certifications" },
      { value: "100%", label: "Indigenous Innovation" }
    ],
    categories: {
      all: "All Members",
      leadership: "Leadership",
      finance: "Finance & Strategy",
      sales: "Sales Team",
      powertrain: "Powertrain & Battery",
      robotics: "Robotics & Software",
      manufacturing: "Plant & Manufacturing",
      advisors: "Advisory Board"
    },
    leadershipTitle: "Executive Leadership",
    leadershipSubtitle: "Guiding AutoNxt with a bold vision for sustainable mechanization and an autonomous future.",
    teamTitle: "Core Engineering & Operations",
    teamSubtitle: "World-class talent designing, building, and perfecting high-torque electric tractors.",
    advisorsTitle: "Strategic Advisory Board",
    advisorsSubtitle: "Industry veterans and domain leaders steering AutoNxt toward global excellence.",
    connectLinkedIn: "Connect on LinkedIn",
    connect: "Connect",
    ctaBadge: "Careers at AutoNxt",
    ctaTitle: "Want to Build the Future of Electric Farming?",
    ctaDesc: "Join a fast-growing team of innovators, thinkers, and builders. Explore open roles across engineering, operations, and software.",
    ctaButton: "View Open Positions",
    teamMembers: [
      {
        name: "Kaustubh Dhonde",
        role: "Chief Executive Officer",
        category: "leadership",
        bio: "Visionary leader driving AutoNxt's mission to revolutionize agriculture with innovative electric vehicle solutions.",
        featured: true
      },
      {
        name: "Pankaj Goyal",
        role: "Co-Founder & COO",
        category: "leadership",
        bio: "Operational strategist ensuring seamless execution and growth, overseeing day-to-day operations and partnerships.",
        featured: true
      },
      {
        name: "Gaurav Borkar",
        role: "Chief Financial Officer",
        category: "finance",
        bio: "Seasoned finance professional and strategic leader directing AutoNxt's financial strategy, fundraising, and corporate governance.",
        featured: true
      },
      {
        name: "Amit Kumar Shivhare",
        role: "Head – Accounts & Finance",
        category: "finance",
        bio: "Senior Accounts & Finance Leader with 15+ years of progressive experience driving financial strategy, governance and business performance."
      },
      {
        name: "Pratik",
        role: "Head of FP&A",
        category: "finance",
        bio: "Chartered Accountant leading corporate finance, FP&A, fundraising modelling, and strategic financial governance."
      },
      {
        name: "Hari Kishan",
        role: "Plant Head",
        category: "manufacturing",
        bio: "Oversees plant operations, ensuring quality and efficiency in every tractor produced."
      },
      {
        name: "Sudipto Deb",
        role: "Lead Power Train Engineer",
        category: "powertrain",
        bio: "Expert in power electronics, responsible for designing and optimizing the electrical systems powering our tractors."
      },
      {
        name: "Vamsi Atluri",
        role: "Lead Mechanical Design Engineer",
        category: "powertrain",
        bio: "Mechanical design innovator, crafting robust and efficient tractor structures for diverse agricultural needs."
      },
      {
        name: "Dr. Dharmateja Adapa",
        role: "Lead Robotics Engineer",
        category: "robotics",
        bio: "Automation expert focused on integrating smart technologies for seamless and reliable tractor performance."
      },
      {
        name: "Tejesh Madireddy",
        role: "Lead Embedded Engineer",
        category: "robotics",
        bio: "Leads embedded systems development, ensuring reliable and efficient hardware-software integration."
      },
      {
        name: "Aswanth Mulupuri",
        role: "Robotics & Automation Engineer",
        category: "robotics",
        bio: "Specialist in automation, developing advanced control systems for autonomous tractor operation."
      },
      {
        name: "Ajinkya Delvi",
        role: "Power Train Engineer",
        category: "powertrain",
        bio: "Works on power train systems, optimizing performance and efficiency."
      },
      {
        name: "Khushpreet Singh",
        role: "Testing & Validation Engineer",
        category: "manufacturing",
        bio: "Responsible for rigorous testing and validation, guaranteeing the reliability and safety of our products."
      },
      {
        name: "Swapnesh Jahagirdar",
        role: "Business Development Manager",
        category: "sales",
        bio: "Focused on identifying new opportunities and fostering relationships to accelerate company expansion."
      }
    ],
    advisorsList: [
      {
        name: "IV-Rao",
        role: "Senior Advisor",
        bio: "Former Executive Advisor & Engineering Head at Maruti Suzuki. Guiding AutoNxt in automotive architecture, systems engineering, and mass-market scalability."
      },
      {
        name: "Ashish Mehta",
        role: "Financial Advisor",
        bio: "Veteran financial strategist advising on capital allocation, venture scale, and sustainable commercial expansion."
      },
      {
        name: "Swadeep Pillarisetti",
        role: "Strategy Consultant",
        bio: "Global strategy expert helping accelerate product-market fit, enterprise sales pipelines, and high-impact partnerships."
      }
    ]
  }
};
